import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import "react-toastify/dist/ReactToastify.css";
import { fill_action } from "../../../actions/fillList_action";
import {
  multi_purpose_centre_add_action,
  multi_purpose_centre_detail_action,
} from "../../../actions/master_actions/multiPurposeCentre_action";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../utils/Loader";
import { Modal, Button } from "react-bootstrap";
import Resizer from "react-image-file-resizer";
import DatePicker from "react-datepicker";
import {
  BASE_URL,
  MasterConsumableActionId,
  MasterTimeSlotActionId,
  MastersecurityChecklistId,
  SittingArrangementActionId,
  TypeOfEventActionId,
  additionalServiceActionId,
  cityActionId,
  countryActionId,
  externalServicesActionId,
  sessionExpireMessage,
  stateActionId,
  timeSlotActionId,
  toastError,
  toastSuccess,
  tokenInavlidMessage,
} from "../../../utils/constants";
import Select from "react-select";
import Header from "../../../common_components/Header";
import moment from "moment";
import { data } from "jquery";
const CustomInput = forwardRef(
  ({ value, onClick, onChange, disabled }, ref) => (
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      onChange={onChange}
      disabled={disabled}
      ref={ref}
    />
  )
);
const customStyles = {
  control: (provided) => ({
    ...provided,
    borderColor: "#c9c9c9", // Blue border color
    boxShadow: "none",
    "&:hover": {
      borderColor: "#80bdff", // Blue border color on hover
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "14px",
    padding: "4px",
    backgroundColor: "#00BCD4", // Blue background color for selected value
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white", // Text color for selected value
    fontSize: "12px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "white",
    "&:hover": {
      backgroundColor: "#00BCD4",
      color: "#fff", // Blue border color on hover
    }, // Remove icon color for selected value
  }),
};
const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_PREVIEW_COUNT = 10;
class MultiPurposeCenterAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //components bool
      isModalDetail: false,
      isLoading: false,
      StatusID: false,
      isOpen: false,
      show: false,
      showNewPriceRow: false,
      showNewSDRow: false,
      setShow: false,
      showNewRow: false,
      showNewRowSitting: false,
      showNewRowInclusive: false,
      showNewRowExternal: false,
      showNewRowConsumable: false,
      showNewRowSecurityChecklist: false,
      editingRowIndex: -1,
      isDisplayCityList: false,
      AdditionalServicesID: "",
      AdditionalServiceID: "",
      editIndex: "",
      //const main form
      userId: "",
      CenterID: "",
      Name: "",
      Code: "",
      AddressLine1: "",
      AddressLine2: "",
      CityID: "",
      StateID: "",
      CountryID: "",
      Countryid: "",
      Pincode: "",
      URL: "",
      MaxPAX: "",
      TypeOfEventID: "",
      Description: "",
      SecurityDepositPricingModel: "",
      AdditionalHourInr: 0,
      AdditionalHourUsd: 0,
      OvernightChargesInr: 0,
      OvernightChargesUsd: 0,
      TimeslotID: "",
      CountryName: "",
      EventName: "",
      //data arrays
      multiCentreData: [],
      selectedEvents: [],
      formFile: "",
      fileName: "",
      formFileType: "",
      getTypeOfEventID: [],
      centerTypeEventIDList: [],
      //fill list
      stateList: [],
      countryList: [],
      cityList: [],
      additionalServiceFillList: [],
      TypeOfEventList: [],
      timeSlotList: [],
      EventName: [],
      ExternalServicesID: "",
      externalServiceFillList: [],
      sittingTypeFillList: [],
      consumableFillList: [],
      securityCheckFillList: [],
      centerPhotoList: [],
      //temp save modal and row
      priceList: [],
      priceRowDetail: {
        CenterPriceID: "",
        TimeslotID: "",
        PriceINR: "",
        PriceUSD: "",
        WithEffectFrom: "",
        isActive: 1,
      },
      SDList: [],
      SDRowDetail: {
        CenterSecurityDepositID: "",
        TimeSlotID: "",
        PriceInINR: "",
        PriceInUSD: "",
        isActive: 1,
      },
      extractedTimeSlotList: [],

      inclusiveList: [],
      inclusiveDetails: {
        CenterServicesID: "",
        ServiceName: "",
        isActive: 1,
      },
      externalList: [],
      externalDetails: {
        CenterServicesID: "",
        ServiceID: "",
        ServiceName: "",
        isActive: 1,
      },
      sittingList: [],
      sittingDetails: {
        ID: "",
        SittingTypeID: "",
        IsActive: 1,
      },
      consumableList: [],
      consumableDetails: {
        ID: "",
        ConsumableID: "",
        isActive: 1,
      },
      securityChecklist: [],
      securityChecklistDetails: {
        CenterSecurityChecklistID: "",
        Name: "",
        isClient: "",
        isActive: 1,
      },

      //inhouseList
      inhouseList: [],
      inhouseDetails: {
        CenterAdditionalServiceID: "",
        AdditionalServiceID: "",
        ServiceType: "",
        MaxQuantity: "",
        ServiceDetails: "",
        Remark: "",
        Quantity: "",
        PriceInINR: "",
        PriceInUSD: "",
        EffectiveDate: "",
        CenterAdditionalServicePricingID: "",
        StatusID: 1,
        Isactive: 1,
      },
      // inhouseSubList: [],
      // inhouseSubDetails: {
      //   Quantity: "",
      //   PriceInINR: "",
      //   PriceInUSD: "",
      //   EffectiveDate: "",
      // },
      // ServiceType: "",
      // ServiceDetails: "",
      // Remark: "",
      //editRows
      //price
      editedPriceRowIndex: null,
      editedPriceRowData: {},
      //Security deposit
      editedSDRowIndex: null,
      editedSDRowData: {},
      //sitting
      editedRowIndexSitting: null,
      editedRowDataSitting: {},
      //consumable
      editedRowIndexConsumable: null,
      editedRowDataConsumable: {},
      //SecurityChecklist
      editedRowIndexSecurityChecklist: null,
      editedRowDataSecurityChecklist: {},
      //inclusive
      editedRowIndexInclusive: null,
      editedRowDataInclusive: {},
      //external
      editedRowIndexExternal: null,
      editedRowDataExternal: {},
      //inhouse
      editedRowIndexInhouseSub: null,
      editedRowDataInhouseSub: {},
      //updateIDs
      CenterPriceID: "",
      CenterTypeOfEventID: "",
      CenterPhotoID: "",
      CenterAdditionalServicesPhotoID: "",
      centerTypeOfEventIDs: [],

      // input validate
      NameErr: "",
      address1Err: "",
      address2Err: "",
      cityErr: "",
      StateErr: "",
      countryErr: "",
      PincodeErr: "",
      urlErr: "",
      paxErr: "",
      eventListErr: "",
      SecurityDepositPricingModelErr: "",
      Status: "",
      downloadUrl: "",
      AdditionalHourInrErr: '',
      AdditionalHourUsdErr: '',
      OvernightChargesInrErr: '',
      OvernightChargesUsdErr: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.multiCentreDetails = this.multiCentreDetails.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }
  componentDidMount() {
    const { userId, CenterID, Status } = this.state;
    this.setState({ Status: this.props.location.state.Status });
    const sortUrl = BASE_URL.split("/api");
    this.setState({ downloadUrl: sortUrl[0] });
    console.log("Props.location.state received:", this.props);
    if (this.props.location.state?.CenterID) {
      this.setState({ CenterID: this.props.location.state.CenterID }, () => {
        this.multiCentreDetails();
      });
    } else {
      this.clearFields();
    }
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getFillList(cityActionId, userId, "", "");
    this.getFillList(stateActionId, userId, "", "");
    this.getFillList(countryActionId, userId, "", "");
    this.getFillList(TypeOfEventActionId, userId, "", "");
    this.getFillList(MasterTimeSlotActionId, userId, "", "");
    this.getFillList(additionalServiceActionId, userId, "", "");
    this.getFillList(externalServicesActionId, userId, "", "");
    this.getFillList(SittingArrangementActionId, userId, "", "");
    this.getFillList(MasterConsumableActionId, userId, "", "");
    this.getFillList(MastersecurityChecklistId, userId, "", "");
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == stateActionId) {
            this.setState({ stateList: data.data, isLoading: false });
          }
          if (value == countryActionId) {
            this.setState({ countryList: data.data, isLoading: false });
          }
          if (value == cityActionId) {
            this.setState({ cityList: data.data, isLoading: false });
          }
          if (value == TypeOfEventActionId) {
            var tempEventArr = [];
            for (var i = 0; i < data.data.length; i++) {
              var eventObj = {};
              eventObj.label = data.data[i].EventName;
              eventObj.value = data.data[i].TypeOfEventID;
              tempEventArr.push(eventObj);
            }
            this.setState({ TypeOfEventList: tempEventArr, isLoading: false });
          }
          if (value == MasterTimeSlotActionId) {
            this.setState({ timeSlotList: data.data, isLoading: false });
          }
          if (value == additionalServiceActionId) {
            this.setState({
              additionalServiceFillList: data.data,
              isLoading: false,
            });
          }
          if (value == externalServicesActionId) {
            this.setState({
              externalServiceFillList: data.data,
              isLoading: false,
            });
          }
          if (value == SittingArrangementActionId) {
            this.setState({
              sittingTypeFillList: data.data,
              isLoading: false,
            });
          }
          if (value == MasterConsumableActionId) {
            this.setState({
              consumableFillList: data.data,
              isLoading: false,
            });
          }
          if (value == MastersecurityChecklistId) {
            this.setState({
              securityCheckFillList: data.data,
              isLoading: false,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  multiCentreDetails() {
    const { CenterID } = this.state;
    if (CenterID) {
      this.props
        .multi_purpose_centre_detail_action(CenterID)
        .then((data) => {
          console.log("center details--------", data.data);
          if (data.error !== 1) {
            //Slot price data
            const priceData0 = data.data[0];
            const updatedPriceList = priceData0.map((priceData) => {
              return {
                CenterPriceID: priceData["CenterPriceID"],
                TimeslotID: priceData.TimeslotID,
                PriceINR: priceData.PriceINR,
                PriceUSD: priceData.PriceUSD,
                WithEffectFrom:
                  priceData.WithEffectFrom !== null
                    ? moment(priceData.WithEffectFrom, "DD-MM-YYYY").format(
                      "YYYY-MM-DD"
                    )
                    : null,
                isActive: 1

              };
            });
            console.log("updatedPriceList", updatedPriceList);
            this.setState({
              priceList: updatedPriceList,
            });

            //main form data
            const mainData1 = data.data[1][0];

            this.setState({
              Code: mainData1["Code"],
              Name: mainData1["Name"],
              AddressLine1: mainData1["AddressLine1"],
              AddressLine2: mainData1["AddressLine2"],
              CityID: mainData1["CityID"],
              StateID: mainData1["StateID"],
              Countryid: mainData1["CountryID"],
              Pincode: mainData1["Pincode"],
              URL: mainData1["URL"],
              MaxPAX: mainData1["MaxPAX"],
              Description: mainData1["Description"],
              getTypeOfEventID:
                mainData1["TypeOfEventID"] != null
                  ? mainData1["TypeOfEventID"]
                  : null,
              // centerPhotoList: centerPhotoList,
              SecurityDepositPricingModel:
                mainData1["SecurityDepositPricingModel"],
              AdditionalHourInr: mainData1["AdditionalHourInr"],
              AdditionalHourUsd: mainData1["AdditionalHourUsd"],
              OvernightChargesInr: mainData1["OvernightChargesInr"],
              OvernightChargesUsd: mainData1["OvernightChargesUsd"]
            });

            //center Type of Event ID
            // const centerTypeEvent3 = data.data[3]; // Assuming data is an array containing subarrays
            // if (Array.isArray(centerTypeEvent3)) {
            //   const centerTypeEventIDList = centerTypeEvent3.filter(
            //     (item) => item.CenterTypeOfEventID && item.TypeOfEventID
            //   );
            //   this.setState({
            //     centerTypeEventIDList: centerTypeEventIDList,
            //   });
            //   console.log(centerTypeEvent3);
            // }
            const centerTypeEvent3 = data.data[3].map((eventData) => {
              return {
                CenterTypeOfEventID: eventData["CenterTypeOfEventID"] ? eventData["CenterTypeOfEventID"] : 0,
                TypeOfEventID: eventData["TypeOfEventID"],
                isActive: 1
              };
            });
            this.setState({ centerTypeEventIDList: centerTypeEvent3 });
            //Center-photoID
            const centerPhotoID4 = data.data[4];
            this.setState({
              CenterPhotoID: centerPhotoID4.filter((data) => data),
            });

            const centerPhotoList = centerPhotoID4
              .filter(
                (item) => item.Filepath && !item.Filepath.includes("undefined")
              )
              .map((item) => ({
                CenterPhotoID: item.CenterPhotoID,
                FilePath: item.Filepath.trim(),
              }));

            console.log("centerPhotoList:", centerPhotoList);
            this.setState({ centerPhotoList: centerPhotoList });
            //sitting
            const sitting5 = data.data[5].map((sittingData) => {
              return {
                ID: sittingData["ID"],
                SittingTypeID: sittingData.SittingTypeID,
                SittingType: sittingData.SittingType,
                IsActive: 1
              };
            });
            this.setState({ sittingList: sitting5 });

            //inclusive
            const inclusive6 = data.data[6].map((inclusiveData) => {
              return {
                CenterServicesID: inclusiveData["CenterServicesID"],
                ServiceName: inclusiveData.ServiceName,
                isActive: 1
              };
            });
            this.setState({ inclusiveList: inclusive6 });
            //exclusive
            const external7 = data.data[7].map((externalData) => {
              return {
                CenterServicesID: externalData["CenterServicesID"],
                ServiceID: externalData.ServiceID,
                ServiceName: externalData.ServiceName,
                isActive: 1
              };
            });
            this.setState({ externalList: external7 });

            const SD8 = data.data[8].map((SDData) => {
              return {
                CenterSecurityDepositID: SDData["CenterSecurityDepositID"],
                CenterID: SDData.CenterID,
                TimeSlotID: SDData.TimeSlotID,
                PriceInINR: SDData.PriceInINR,
                PriceInUSD: SDData.PriceInUSD,
                isActive: SDData.isActive,
              };
            });
            this.setState({ SDList: SD8 });

            const consumable9 = data.data[9].map((ConsumableData) => {
              return {
                ID: ConsumableData.ID,
                ConsumableID: ConsumableData.ConsumableID,
                Consumable: ConsumableData.Consumable,
                isActive: 1
              };
            });
            this.setState({ consumableList: consumable9 });
            console.log(consumable9, "consumable9")

            const securityChecklist10 = data.data[10].map((securityData) => {
              return {
                CenterSecurityChecklistID:
                  securityData.CenterSecurityChecklistID,
                Name: securityData.Name,
                isClient: securityData.isClient == true ? 1 : 0,
                isActive: 1
              };
            });
            this.setState({ securityChecklist: securityChecklist10 });

            const additionalServiceData = data.data[1][0];
            const quantityRowData = data.data[1][0];

            const secondIndexData = data.data[2];

            const updatedAdditionalPriceList = secondIndexData.map(
              (additionalData) => {
                return {
                  CenterAdditionalServicePricingID:
                    additionalData["CenterAdditionalServicePricingID"],
                  Quantity: additionalData.Quantity,
                  PriceInINR: additionalData.PriceInINR,
                  PriceInUSD: additionalData.PriceInUSD,
                  EffectiveDate:
                    additionalData.EffectiveDate !== null
                      ? moment(
                        additionalData.EffectiveDate,
                        "YYYY-MM-DD"
                      ).toDate()
                      : null,
                };
              }
            );
            //additional Full Modal
            const additionalFull2 = data.data[2];
            const updatedAdditionalList = additionalFull2.map(
              (additionalData) => {
                var subList = [];
                subList.push({
                  Quantity: additionalData.Quantity,
                  PriceInINR: additionalData.PriceInINR,
                  PriceInUSD: additionalData.PriceInUSD,
                  EffectiveDate: additionalData.EffectiveDate,
                  CenterAdditionalServicePricingID:
                    additionalData.CenterAdditionalServicePricingID,
                  Isactive: 1
                });
                return {
                  CenterAdditionalServiceID:
                    additionalData["CenterAdditionalServiceID"],
                  AdditionalServiceID: additionalData.AdditionalServiceID,
                  ServiceType: additionalData.ServiceType,
                  MaxQuantity: additionalData.MaxQuantity,
                  ServiceDetails: additionalData.ServiceDetails,
                  Remark: additionalData.Remark,
                  Quantity: additionalData.Quantity,
                  PriceInINR: additionalData.PriceInINR,
                  PriceInUSD: additionalData.PriceInUSD,
                  EffectiveDate:
                    additionalData.EffectiveDate !== null
                      ? moment(
                        additionalData.EffectiveDate,
                        "DD-MM-YYYY"
                      ).format("YYYY-MM-DD")
                      : null,
                  CenterAdditionalServicePricingID:
                    additionalData.CenterAdditionalServicePricingID,
                  StatusID: 1
                  // inhouseSubList:  additionalData.CenterAdditionalServicePricingID!=null?subList:[]
                };
              }
            );
            this.setState({
              //second array
              inhouseList: updatedAdditionalList,
              inhouseDetails: {
                ...this.state.inhouseDetails,
                CenterAdditionalServiceID: additionalServiceData.CenterAdditionalServiceID,
                AdditionalServiceID: additionalServiceData.AdditionalServiceID,
                ServiceType: additionalServiceData.ServiceType,
                MaxQuantity: additionalServiceData.MaxQuantity,
                ServiceDetails: additionalServiceData.ServiceDetails,
                Remark: additionalServiceData.Remark,
                CenterAdditionalServicePricingID: additionalServiceData.CenterAdditionalServicePricingID,
                Quantity: additionalServiceData.Quantity,
                PriceInINR: additionalServiceData.PriceInINR,
                PriceInUSD: additionalServiceData.PriceInUSD,
                EffectiveDate: new Date(additionalServiceData.EffectiveDate),
                StatusID: 1, Isactive: 1
              },
            });
            console.log(
              updatedAdditionalList,
              "updatedAdditionalList---------"
            );
            this.setState({ isLoading: false });

            setTimeout(() => {
              if (this.state.getTypeOfEventID != null) {
                const getEventIdArray = [];
                const newEventArray = [];
                getEventIdArray.push(this.state.getTypeOfEventID.split(","));
                console.log(getEventIdArray, "2");
                getEventIdArray[0].map((data, index) => {
                  for (let i = 0; i < this.state.TypeOfEventList.length; i++) {
                    if (data == this.state.TypeOfEventList[i]["value"]) {
                      newEventArray.push({
                        label: this.state.TypeOfEventList[i]["label"],
                        value: this.state.TypeOfEventList[i]["value"],
                      });
                    }
                  }
                });
                this.setState({ EventName: newEventArray });
              }
            }, 300);
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toastError(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toastError(data.data, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  //change
  //price
  handleAddRowPrice() {
    const {
      priceList,
      priceRowDetail,
      timeSlotList,
      CenterPriceID,
      extractedTimeSlotList,
    } = this.state;

    if (
      priceRowDetail.TimeslotID == "" ||
      priceRowDetail.TimeslotID == null ||
      priceRowDetail.TimeslotID == "select"
    ) {
      toastError("Please Select Time Slot", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (priceRowDetail.PriceINR == "") {
      toastError("Please enter Inr Price", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (priceRowDetail.PriceUSD == "") {
      toastError("Please enter Usd Price", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (priceRowDetail.WithEffectFrom == "") {
      toastError("Please Select Effective Date", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      const selectedTimeslotID = parseInt(priceRowDetail.TimeslotID, 10);
      // Find the selected timeslot from timeSlotList based on the parsed TimeslotID
      const selectedTimeslot = timeSlotList.find(
        (timeslot) => timeslot.TimeSlotID === selectedTimeslotID
      );
      // Make sure to use the selected TimeslotID and other properties from the state
      const newPriceRow = {
        CenterPriceID: CenterPriceID,
        TimeslotID: selectedTimeslotID,
        PriceINR: priceRowDetail.PriceINR,
        PriceUSD: priceRowDetail.PriceUSD,
        WithEffectFrom: priceRowDetail.WithEffectFrom || null,
        isActive: 1,
      };
      this.setState(
        {
          priceList: [...priceList, newPriceRow], // Add the updated row to priceList
          priceRowDetail: {
            TimeslotID: "",
            PriceINR: "",
            PriceUSD: "",
            WithEffectFrom: "" || null,
            isActive: 1,
          },
          selectedTimeslot: selectedTimeslot, // Store the selected timeslot in state
          showNewPriceRow: false,
        },
        () => {
          console.log("priceRowDetail", priceRowDetail);

          // Extract the selected TimeslotID and add it to extractedTimeSlotList
          const extractedTimeSlot = timeSlotList.find(
            (timeslot) => timeslot.TimeSlotID === selectedTimeslotID
          );
          if (extractedTimeSlot) {
            this.setState(
              {
                extractedTimeSlotList: [
                  ...extractedTimeSlotList,
                  extractedTimeSlot,
                ],
              },
              () => {
                console.log(
                  this.state.extractedTimeSlotList,
                  priceList,
                  "extractedTimeSlotList"
                );
              }
            );
          }
        }
      );
    }
  }

  saveEditedPriceRow(index) {
    const { priceList, editedPriceRowData, priceRowDetail } = this.state;

    if (
      editedPriceRowData.TimeslotID == "" ||
      editedPriceRowData.TimeslotID == null ||
      editedPriceRowData.TimeslotID == "select"
    ) {
      toastError("Please Select Time Slot", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (editedPriceRowData.PriceINR == "") {
      toastError("Please enter INR Price", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (editedPriceRowData.PriceUSD == "") {
      toastError("Please enter USD Price", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (editedPriceRowData.WithEffectFrom == "") {
      toastError("Please Select Effective Date", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      // Update TimeslotID in editedPriceRowData with value from priceRowDetail
      editedPriceRowData.TimeslotID = parseInt(priceRowDetail.TimeslotID);
      console.log(editedPriceRowData, "editedPriceRowData --------");
      const updatedPriceList = [...priceList];
      updatedPriceList[index] = editedPriceRowData;
      this.setState({
        priceList: updatedPriceList,
        editedPriceRowIndex: null,
        editedPriceRowData: {},
        priceRowDetail: {
          TimeslotID: "",
        },
      });
    }
  }

  toggleNewPriceRow() {
    this.setState((prevState) => ({
      showNewPriceRow: !prevState.showNewPriceRow,
    }));
  }
  handleDateChange = (selectedDate) => {
    this.setState((prevState) => ({
      quantityRowDetail: {
        ...prevState.quantityRowDetail,
        EffectiveDate: selectedDate, // Store the selected Date object
      },
    }));
  };
  handleKeyPressPrice(event) {
    if (event.key === "Enter") {
      this.handleAddRow();
    }
  }
  handleEditPriceRow(index, data) {
    this.setState({
      editedPriceRowIndex: index,
      editedPriceRowData: { ...data },
    });
  }
  handlePriceRowEditFieldChange(index, field, value) {
    const editedDataCopy = { ...this.state.editedPriceRowData };
    editedDataCopy[field] = value;
    this.setState({ editedPriceRowData: editedDataCopy });
  }

  cancelEditPriceRow() {
    this.setState({
      editedPriceRowIndex: null,
      editedPriceRowData: {},
    });
  }
  handleDeletePriceRow(index) {
    const { priceList } = this.state;
    const updatedList = priceList.map((row, rowIndex) => {
      if (rowIndex === index) {
        return { ...row, isActive: 0 };
      }
      return row;
    });
    this.setState({
      priceList: updatedList,
    });
  }
  //Security Deposit
  handleAddRowSD() {
    const { SDList, SDRowDetail, timeSlotList, CenterSecurityDepositID } =
      this.state;

    if (
      SDRowDetail.TimeSlotID == "" ||
      SDRowDetail.TimeSlotID == null ||
      SDRowDetail.TimeSlotID == "select"
    ) {
      toastError("Please Select Time Slot", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (SDRowDetail.PriceInINR == "") {
      toastError("Please enter Inr Price", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (SDRowDetail.PriceInUSD == "") {
      toastError("Please enter Usd Price", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      const selectedTimeslotID = parseInt(SDRowDetail.TimeSlotID, 10);
      // Find the selected timeslot from timeSlotList based on the parsed TimeslotID
      const selectedTimeslot = timeSlotList.find(
        (timeslot) => timeslot.TimeSlotID === selectedTimeslotID
      );
      // Make sure to use the selected TimeslotID and other properties from the state
      const newSDRow = {
        CenterSecurityDepositID: CenterSecurityDepositID, // Pass the CenterPriceID
        TimeSlotID: selectedTimeslotID,
        PriceInINR: SDRowDetail.PriceInINR,
        PriceInUSD: SDRowDetail.PriceInUSD,
        isActive: 1,
      };
      this.setState({
        SDList: [...SDList, newSDRow], // Add the updated row to SDList
        SDRowDetail: {
          TimeSlotID: "",
          PriceInINR: "",
          PriceInUSD: "",
          isActive: 1,
        },
        selectedTimeslot: selectedTimeslot, // Store the selected timeslot in state
        showNewSDRow: false,
      });
      console.log("SDRowDetail", SDRowDetail);
    }
  }
  saveEditedSDRow(index) {
    const { SDList, editedSDRowData, SDRowDetail } = this.state;

    if (
      editedSDRowData.TimeSlotID == "" ||
      editedSDRowData.TimeSlotID == null ||
      editedSDRowData.TimeSlotID == "select"
    ) {
      toastError("Please Select Time Slot", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (editedSDRowData.PriceInINR == "") {
      toastError("Please enter INR Price", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (editedSDRowData.PriceInUSD == "") {
      toastError("Please enter USD Price", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      // Update TimeslotID in editedSDRowData with value from SDRowDetail
      editedSDRowData.TimeSlotID = parseInt(SDRowDetail.TimeSlotID);
      console.log(editedSDRowData, "editedSDRowData --------");
      const updatedSDList = [...SDList];
      updatedSDList[index] = editedSDRowData;
      this.setState({
        SDList: updatedSDList,
        editedSDRowIndex: null,
        editedSDRowData: {},
        SDRowDetail: {
          TimeSlotID: "",
        },
      });
    }
  }

  toggleNewSDRow() {
    const { priceList } = this.state;
    console.log(priceList, "check");
    if (priceList.length === 0) {
      toastError("Kindly Fill Pricing Details", {
        position: "top-center",
        theme: "colored",
        autoClose: 2000,
        hideProgressBar: true,
      });
    } else {
      this.setState((prevState) => ({
        showNewSDRow: !prevState.showNewSDRow,
      }));
    }
  }

  handleKeyPressSD(event) {
    if (event.key === "Enter") {
      this.handleAddRowSD();
    }
  }
  handleEditSDRow(index, data) {
    this.setState({
      editedSDRowIndex: index,
      editedSDRowData: { ...data },
    });
  }
  handleSDRowEditFieldChange(index, field, value) {
    const editedDataCopy = { ...this.state.editedSDRowData };
    editedDataCopy[field] = value;
    this.setState({ editedSDRowData: editedDataCopy });
  }

  cancelEditSDRow() {
    this.setState({
      editedSDRowIndex: null,
      editedSDRowData: {},
    });
  }
  handleDeleteSDRow(index) {
    const { SDList } = this.state;
    const updatedList = SDList.map((row, rowIndex) => {
      if (rowIndex === index) {
        return { ...row, isActive: 0 };
      }
      return row;
    });
    this.setState({
      SDList: updatedList,
    });
  }

  //inclusive services
  handleAddRowInclusive() {
    const { inclusiveList, inclusiveDetails } = this.state;
    if (inclusiveDetails.ServiceName == "") {
      toastError("Please Enter Inclusive Service", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    } else {
      const newRow = {
        CenterServicesID: inclusiveDetails.CenterServicesID,
        ServiceName: inclusiveDetails.ServiceName,
        isActive: 1,
      };
      // const newRow = { ...inclusiveDetails };
      this.setState({
        inclusiveList: [...inclusiveList, newRow],
        inclusiveDetails: {
          CenterServicesID: "",
          ServiceName: "",
          isActive: 1,
        },
        showNewRowInclusive: false, // Hide the "Add" row after adding
      });
    }
  }

  toggleNewRowInclusive() {
    this.setState((prevState) => ({
      showNewRowInclusive: !prevState.showNewRowInclusive,
    }));
  }
  handleKeyPressInclusive(event) {
    if (event.key === "Enter") {
      this.handleAddRowInclusive();
    }
  }
  handleEditRowInclusive(index, data) {
    this.setState({
      editedRowIndexInclusive: index,
      editedRowDataInclusive: { ...data },
    });
  }
  handleRowEditFieldChangeInclusive(index, field, value) {
    const editedDataCopyInclusive = { ...this.state.editedRowDataInclusive };
    editedDataCopyInclusive[field] = value;
    this.setState({ editedRowDataInclusive: editedDataCopyInclusive });
  }

  saveEditedRowInclusive(index) {
    const { inclusiveList, editedRowDataInclusive } = this.state;
    if (editedRowDataInclusive.ServiceName == "") {
      toastError("Please select Inclusive Service", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    } else {
      const updatedList = [...inclusiveList];
      updatedList[index] = editedRowDataInclusive;
      this.setState({
        inclusiveList: updatedList,
        editedRowIndexInclusive: null,
        editedRowDataInclusive: {},
      });
    }
  }
  cancelEditRowInclusive() {
    this.setState({
      editedRowIndexInclusive: null,
      editedRowDataInclusive: {},
    });
  }
  handleDeleteRowInclusive(index, CenterServicesID) {
    const { inclusiveList } = this.state;
    let updatedList;
    if (CenterServicesID) {
      updatedList = inclusiveList.map(row =>
        row.CenterServicesID === CenterServicesID ? { ...row, isActive: 0 } : row
      );
    } else {
      updatedList = inclusiveList.map((row, rowIndex) =>
        rowIndex === index ? { ...row, isActive: 0 } : row
      );
    }
    this.setState({ inclusiveList: updatedList });
  }

  //external services
  handleAddRowExternal() {
    const { externalList, externalDetails, externalServiceFillList } =
      this.state;
    console.log(externalDetails.ServiceID, "55555555");
    if (externalDetails.ServiceID == "" || externalDetails.ServiceID == null) {
      toastError("Please Select External Services", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    } else {
      const selectedExternalServicesID = parseInt(
        externalDetails.ServiceID,
        10
      );

      // Find the selected external service from externalServiceFillList based on the parsed ExternalServicesID
      const selectedExternalServices = externalServiceFillList.find(
        (extServ) => extServ.ExternalServicesID === selectedExternalServicesID
      );

      const newRow = {
        CenterServicesID: externalDetails.CenterServicesID,
        ServiceID: selectedExternalServicesID,
        ServiceName: externalDetails.ServiceName,
        isActive: 1,
      };
      console.log(newRow, "newRow");

      this.setState({
        externalList: [...externalList, newRow],
        selectedExternalServices: selectedExternalServices, // Correctly set the selectedExternalServices state
        externalDetails: {
          CenterServicesID: "",
          ServiceID: "",
          ServiceName: "",
          isActive: 1,
        },
        showNewRowExternal: false, // Hide the "Add" row after adding
      });
    }
  }

  toggleNewRowExternal() {
    this.setState((prevState) => ({
      showNewRowExternal: !prevState.showNewRowExternal,
    }));
  }
  handleKeyPressExternal(event) {
    if (event.key === "Enter") {
      this.handleAddRowExternal();
    }
  }
  handleEditRowExternal(index, data) {
    this.setState({
      editedRowIndexExternal: index,
      editedRowDataExternal: { ...data },
    });
  }
  handleRowEditFieldChangeExternal(index, field, value) {
    const editedDataCopy = { ...this.state.editedRowDataExternal };
    editedDataCopy[field] = value;

    this.setState({ editedRowDataExternal: editedDataCopy });
  }

  saveEditedRowExternal(index) {
    const { externalList, editedRowDataExternal, externalDetails } = this.state;
    console.log(externalDetails, "check check check");
    if (
      externalDetails.ServiceID == "" ||
      externalDetails.ServiceID == null ||
      externalDetails.ServiceID == "Select"
    ) {
      toastError("Please Select External Services", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    } else {
      externalDetails.ServiceID = parseInt(externalDetails.ServiceID);
      const updatedList = [...externalList];
      updatedList[index] = externalDetails;
      this.setState({
        externalList: updatedList,
        editedRowIndexExternal: null,
        editedRowDataExternal: {},
        externalDetails: {},
        externalDetails: {
          CenterServicesID: "",
          ServiceID: "",
          ServiceName: "",
          isActive: null,
        },
      });
    }
  }
  cancelEditRowExternal() {
    this.setState({
      editedRowIndexExternal: null,
      editedRowDataExternal: {},
    });
  }
  handleDeleteRowExternal(index, ExternalServicesID) {
    const { externalList } = this.state;
    let updatedList;

    if (ExternalServicesID) {
      updatedList = externalList.map(row =>
        row.ExternalServicesID === ExternalServicesID
          ? { ...row, isActive: 0 }
          : row
      );
    } else {
      updatedList = externalList.map((row, rowIndex) =>
        rowIndex === index
          ? { ...row, isActive: 0 }
          : row
      );
    }

    this.setState({ externalList: updatedList });
  }

  //sitting type
  handleAddRowSitting() {
    const { sittingList, sittingDetails } = this.state;
    console.log(sittingDetails, sittingList, "sitting");
    if (sittingDetails.SittingTypeID == "") {
      toastError("Please Select Seating Type", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      const newRow = {
        ID: sittingDetails.ID,
        SittingTypeID: sittingDetails.SittingTypeID,
        IsActive: 1,
      };
      // const newRow = { ...sittingDetails };
      this.setState({
        sittingList: [...sittingList, newRow],
        sittingDetails: {
          ID: "",
          SittingTypeID: "",
          IsActive: null,
        },
        showNewRowSitting: false, // Hide the "Add" row after adding
      });
    }
  }

  toggleNewRowSitting() {
    this.setState((prevState) => ({
      showNewRowSitting: !prevState.showNewRowSitting,
    }));
  }
  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.handleAddRowSitting();
    }
  }
  handleEditRowSitting(index, data) {
    this.setState({
      editedRowIndexSitting: index,
      editedRowDataSitting: { ...data },
    });
  }
  handleRowEditFieldChangeSitting(index, field, value) {
    const editedDataCopy = { ...this.state.editedRowDataSitting };
    editedDataCopy[field] = value;

    this.setState({ editedRowDataSitting: editedDataCopy });
  }

  saveEditedRowSitting(index) {
    const { sittingList, editedRowDataSitting, sittingDetails } = this.state;
    if (
      sittingDetails.SittingTypeID == "" ||
      sittingDetails.SittingTypeID == null ||
      sittingDetails.SittingTypeID == "Select"
    ) {
      toastError("Please Select Sitting Type", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      sittingDetails.SittingTypeID = parseInt(sittingDetails.SittingTypeID);
      const updatedList = [...sittingList];
      updatedList[index] = sittingDetails;
      this.setState({
        sittingList: updatedList,
        editedRowIndexSitting: null,
        editedRowDataSitting: {},
      });
    }
  }
  cancelEditRowSitting() {
    this.setState({
      editedRowIndexSitting: null,
      editedRowDataSitting: {},
    });
  }
  handleDeleteRowSitting(index, SittingTypeID) {
    const { sittingList } = this.state;
    let updatedList;

    if (SittingTypeID) {
      updatedList = sittingList.map(row =>
        row.SittingTypeID === SittingTypeID ? { ...row, IsActive: 0 } : row
      );
    } else {
      updatedList = sittingList.map((row, rowIndex) =>
        rowIndex === index ? { ...row, IsActive: 0 } : row
      );
    }
    this.setState({ sittingList: updatedList });
  }
  //consumable
  handleAddRowConsumable() {
    const { consumableList, consumableDetails } = this.state;
    console.log(consumableDetails, consumableList, "consumable");
    if (consumableDetails.ConsumableID == "") {
      toastError("Please Select consumable", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      const newRow = {
        ID: consumableDetails.ID,
        ConsumableID: consumableDetails.ConsumableID,
        isActive: 1,
      };
      // const newRow = { ...consumableDetails };
      this.setState({
        consumableList: [...consumableList, newRow],
        consumableDetails: {
          ID: "",
          ConsumableID: "",
          isActive: null,
        },
        showNewRowConsumable: false, // Hide the "Add" row after adding
      });
    }
  }

  toggleNewRowConsumable() {
    this.setState((prevState) => ({
      showNewRowConsumable: !prevState.showNewRowConsumable,
    }));
  }
  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.handleAddRowConsumable();
    }
  }
  handleEditRowConsumable(index, data) {
    this.setState({
      editedRowIndexConsumable: index,
      editedRowDataConsumable: { ...data },
    });
  }
  handleRowEditFieldChangeConsumable(index, field, value) {
    const editedDataCopy = { ...this.state.editedRowDataConsumable };
    editedDataCopy[field] = value;

    this.setState({ editedRowDataConsumable: editedDataCopy });
  }

  saveEditedRowConsumable(index) {
    const { consumableList, editedRowDataConsumable, consumableDetails } =
      this.state;
    if (
      consumableDetails.ConsumableID == "" ||
      consumableDetails.ConsumableID == null ||
      consumableDetails.ConsumableID == "Select"
    ) {
      toastError("Please Select Consumable", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      consumableDetails.ConsumableID = parseInt(consumableDetails.ConsumableID);
      const updatedList = [...consumableList];
      updatedList[index] = consumableDetails;
      this.setState({
        consumableList: updatedList,
        editedRowIndexConsumable: null,
        editedRowDataConsumable: {},
      });
    }
  }
  cancelEditRowConsumable() {
    this.setState({
      editedRowIndexConsumable: null,
      editedRowDataConsumable: {},
    });
  }
  handleDeleteRowConsumable(index, ConsumableID) {
    const { consumableList } = this.state;
    let updatedList;
    if (ConsumableID) {
      updatedList = consumableList.map(row =>
        row.ConsumableID === ConsumableID ? { ...row, isActive: 0 } : row
      );
    } else {
      updatedList = consumableList.map((row, rowIndex) =>
        rowIndex === index ? { ...row, isActive: 0 } : row
      );
    }
    this.setState({ consumableList: updatedList });
  }

  //Security Checklist
  handleAddRowSecurityChecklist() {
    const { securityChecklist, securityChecklistDetails } = this.state;
    console.log(
      securityChecklistDetails,
      securityChecklist,
      "SecurityChecklist"
    );

    if (securityChecklistDetails.Name === "") {
      toastError("Please Enter Security Checklist Name", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (
      securityChecklistDetails.isClient === "" ||
      securityChecklistDetails.isClient === "Select" ||
      securityChecklistDetails.isClient === null
    ) {
      toastError("Please Select Security Checklist", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      const newRow = {
        CenterSecurityChecklistID:
          securityChecklistDetails.CenterSecurityChecklistID,
        Name: securityChecklistDetails.Name,
        isClient: securityChecklistDetails.isClient,
        isActive: 1,
      };
      // const newRow = { ...securityChecklistDetails };
      this.setState({
        securityChecklist: [...securityChecklist, newRow],
        securityChecklistDetails: {
          CenterSecurityChecklistID: "",
          Name: "",
          isClient: "",
          isActive: null,
        },
        showNewRowSecurityChecklist: false,
      });
    }
  }

  toggleNewRowSecurityChecklist() {
    this.setState((prevState) => ({
      showNewRowSecurityChecklist: !prevState.showNewRowSecurityChecklist,
    }));
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.handleAddRowSecurityChecklist();
    }
  }

  handleEditRowSecurityChecklist(index, data) {
    this.setState({
      editedRowIndexSecurityChecklist: index,
      editedRowDataSecurityChecklist: { ...data },
    });
  }

  handleRowEditFieldChangeSecurityChecklist(index, field, value) {
    const editedDataCopy = { ...this.state.editedRowDataSecurityChecklist };
    editedDataCopy[field] = value;

    this.setState({ editedRowDataSecurityChecklist: editedDataCopy });
  }

  saveEditedRowSecurityChecklist(index) {
    const { securityChecklist, editedRowDataSecurityChecklist } = this.state;

    if (editedRowDataSecurityChecklist.Name === "") {
      toastError("Please Enter Security Checklist Name", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (
      editedRowDataSecurityChecklist.isClient === "" ||
      editedRowDataSecurityChecklist.isClient === "Select" ||
      editedRowDataSecurityChecklist.isClient === null
    ) {
      toastError("Please Select Security Checklist", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      const updatedList = [...securityChecklist];
      updatedList[index] = editedRowDataSecurityChecklist;
      this.setState({
        securityChecklist: updatedList,
        editedRowIndexSecurityChecklist: null,
        editedRowDataSecurityChecklist: {},
      });
    }
  }

  cancelEditRowSecurityChecklist() {
    this.setState({
      editedRowIndexSecurityChecklist: null,
      editedRowDataSecurityChecklist: {},
    });
  }

  handleDeleteRowSecurityChecklist(index, CenterSecurityChecklistID) {
    const { securityChecklist } = this.state;
    let updatedList;

    if (CenterSecurityChecklistID) {
      updatedList = securityChecklist.map(row =>
        row.CenterSecurityChecklistID === CenterSecurityChecklistID ? { ...row, isActive: 0 } : row
      );
    } else {
      updatedList = securityChecklist.map((row, rowIndex) =>
        rowIndex === index ? { ...row, isActive: 0 } : row
      );
    }
    this.setState({ securityChecklist: updatedList });
  }

  //dependency

  navigateBackMultiCentre() {
    this.props.navigate("/multi_purpose_centre");
  }
  clearFields() {
    this.setState({
      CenterID: "",
      Code: this.props.location.state.Code,
      Name: "",
      AddressLine1: "",
      AddressLine2: "",
      CityID: "",
      StateID: "",
      CountryID: "",
      Pincode: "",
      URL: "",
      MaxPAX: "",
      Description: "",
    });
  }

  handleFileChange = async (e) => {
    e.preventDefault();
    const files = Array.from(e.target.files);
    const finalImageArray = [];

    for (const file of files) {
      if (file.size > 2097152) {
        // Check if the file size is more than 2MB
        toastError("File size more than 2MB is not allowed.", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
        continue;
      }

      if (
        file.name.toLowerCase().includes(".jpeg") ||
        file.name.toLowerCase().includes(".png") ||
        file.name.toLowerCase().includes(".jpg")
      ) {
        const image = await this.resizeFile(file);

        // Separate file name and file type
        const fileNameWithoutExtension = file.name.substring(
          0,
          file.name.lastIndexOf(".")
        );
        const fileExtension = file.name.split(".").pop();

        finalImageArray.push({
          fileName: fileNameWithoutExtension,
          formFileType: fileExtension,
          formFile: image,
        });
      } else {
        toastError("Only .jpeg, .png, .jpg files are allowed", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    }

    this.setState((prevState) => ({
      centerPhotoList: [...prevState.centerPhotoList, ...finalImageArray],
    }));
  };

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        "JPEG",
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300
      );
    });

  handleRemoveImage = (index) => {
    this.setState((prevState) => ({
      centerPhotoList: prevState.centerPhotoList.filter((_, i) => i !== index),
    }));
  };

  renderPreview = () => {
    const { centerPhotoList, downloadUrl } = this.state;

    if (!centerPhotoList || centerPhotoList.length === 0) {
      return null;
    }

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          margin: "1rem",
          gap: "2rem",
        }}
      >
        {centerPhotoList.map((photo, index) => (
          <div
            key={index}
            className="uploaded-image"
            style={{ marginBottom: "10px" }}
          >
            {console.log(photo, "centerphotoooooooo")}
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
                src={photo.formFile || `${downloadUrl + photo.FilePath}`}
                alt={`Preview ${index + 1}`}
                style={{ width: "200px", height: "200px" }}
              />
              <span
                className="remove-btn"
                onClick={() => this.handleRemoveImage(index)}
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  borderRadius: "50%",
                  padding: "4px",
                  cursor: "pointer",
                }}
              >
                X
              </span>
            </div>
          </div>
        ))}
      </div>
    );
  };

  inputValidate() {
    const {
      Name,
      AddressLine1,
      AddressLine2,
      CityID,
      StateID,
      Countryid,
      Pincode,
      URL,
      MaxPAX,
      SecurityDepositPricingModel,
      AdditionalHourInr, AdditionalHourUsd, OvernightChargesInr, OvernightChargesUsd
    } = this.state;

    if (CityID == "" || CityID == null || CityID == "Select") {
      this.setState({ cityErr: "Please select City" });
    }
    if (StateID == "" || StateID == null || StateID == "Select") {
      this.setState({ StateErr: "Please select State" });
    }
    if (Countryid == "" || Countryid == null || Countryid == "Select") {
      this.setState({ countryErr: "Please select Country" });
    }
    if (Name == "" || Name == null) {
      this.setState({ NameErr: "Please enter Center Name" });
    }
    if (AddressLine1 == "" || AddressLine1 == null) {
      this.setState({ address1Err: "Please enter Address Line 1" });
    }
    if (AddressLine2 == "" || AddressLine2 == null) {
      this.setState({ address2Err: "Please enter Address Line 1" });
    }
    if (Pincode == "" || Pincode == null) {
      this.setState({ PincodeErr: "Please Enter Pincode" });
    }
    if (URL == "" || URL == null) {
      this.setState({ urlErr: "Please Enter URL" });
    }
    if (MaxPAX == "" || MaxPAX == null) {
      this.setState({ paxErr: "Please Enter PAX" });
    }
    const isEmpty = (val) => val === "" || val === null;

    if (isEmpty(AdditionalHourInr)) {
      this.setState({ AdditionalHourInrErr: "Please Enter Additional Hour INR" });
    }

    if (isEmpty(AdditionalHourUsd)) {
      this.setState({ AdditionalHourUsdErr: "Please Enter Additional Hour USD" });
    }

    if (isEmpty(OvernightChargesInr)) {
      this.setState({ OvernightChargesInrErr: "Please Enter Overnight Charges INR" });
    }

    if (isEmpty(OvernightChargesUsd)) {
      this.setState({ OvernightChargesUsdErr: "Please Enter Overnight Charges USD" });
    }

    if (
      SecurityDepositPricingModel == "" ||
      SecurityDepositPricingModel == null ||
      SecurityDepositPricingModel == "Select"
    ) {
      this.setState({
        SecurityDepositPricingModelErr:
          "Please Select Security Deposit Pricing Model",
      });
    }
  }

  //crud
  handleSubmit() {
    const {
      userId,
      CenterID,
      Name,
      Code,
      AddressLine1,
      AddressLine2,
      CityID, // Use CityName for getting CityID
      StateID,
      Countryid,
      Pincode,
      URL,
      MaxPAX,
      Description,
      SecurityDepositPricingModel,
      priceList,
      EventName,
      centerPhotoList,
      centerTypeOfEventID,
      centerTypeOfEventIDs,
      sittingList,
      inclusiveList,
      externalList,
      inhouseList,
      SDList,
      consumableList,
      securityChecklist,
      NameErr,
      Status, centerTypeEventIDList,
      AdditionalHourInr,
      AdditionalHourUsd,
      OvernightChargesInr,
      OvernightChargesUsd,
    } = this.state;
    console.log(Status, "EventName");
    setTimeout(() => {
      this.inputValidate();
    }, 100);
    if (Name == "") {
      toastError("Please enter Center Name");
    } else if (AddressLine1 == "") {
      toastError("Please enter Address Line 1");
    } else if (AddressLine2 == "") {
      toastError("Please enter Address Line 1");
    } else if (Pincode == "") {
      toastError("Please enter Pincode");
    } else if (URL == "") {
      toastError("Please enter URL");
    } else if (MaxPAX == "") {
      toastError("Please enter Pax");
    } else if (CityID == "" || CityID == null || CityID == "select") {
      toastError("Please select City");
    } else if (StateID == "" || StateID == null || StateID == "select") {
      toastError("Please select State");
    } else if (Countryid == "" || Countryid == null || Countryid == "select") {
      toastError("Please select Country");
    }  else if (
      SecurityDepositPricingModel == "" ||
      SecurityDepositPricingModel == null ||
      SecurityDepositPricingModel == "select"
    ) {
      toastError("Please select Security Deposit Pricing Model");
    } else if (EventName.length === 0) {
      this.setState({ eventListErr: "Kindly Select Events" }, () => {
        toastError("Kindly select Events");
      });
    } else if (centerPhotoList.length === 0) {
      toastError("Kindly select Center Photos");
    } else if (priceList.length === 0) {
      toastError("Kindly select Center Pricing and Slots");
    } else if (SDList.length === 0) {
      toastError("Kindly select Security Deposit Details");
    } else if (sittingList.length === 0) {
      toastError("Kindly select Seating Type");
    } else if (consumableList.length === 0) {
      toastError("Kindly select Consumables");
    } else if (inclusiveList.length === 0) {
      toastError("Kindly select Inclusive Services");
    } else if (externalList.length === 0) {
      toastError("Kindly select External Services");
    } else if (inhouseList.length === 0) {
      toastError("Kindly select Inhouse Services");
    } else {
      const StatusID = CenterID == "" || CenterID == null ? 1 : Status == "Active" ? 1 : 0;
      console.log(EventName, "lala")
      // Create eventNewArr from EventName and centerTypeOfEventIDs
      const eventNewArr = EventName.map((item, index) => ({
        TypeOfEventID: item.value,
        CenterTypeOfEventID: centerTypeOfEventIDs[index],
        isActive: 1, // Default to 0, will update later if there's a match
      }));

      // Map through centerTypeEvent3 and update IsActive in eventNewArr based on matches
      centerTypeEventIDList.map((eventData) => {
        // Find matching item in eventNewArr
        const matchingItem = eventNewArr.find(
          (event) =>
            event.TypeOfEventID === eventData.TypeOfEventID &&
            event.CenterTypeOfEventID === eventData.CenterTypeOfEventID
        );

        if (matchingItem) {
          // If there's a match, set IsActive to 1
          matchingItem.isActive = 1;
        } else {
          // If no match, add the item with IsActive set to 1
          eventNewArr.push({
            CenterTypeOfEventID: eventData.CenterTypeOfEventID ? eventData.CenterTypeOfEventID : 0,
            TypeOfEventID: eventData.TypeOfEventID,
            isActive: 0,
          });
        }

        return {
          CenterTypeOfEventID: eventData["CenterTypeOfEventID"],
          TypeOfEventID: eventData["TypeOfEventID"],
          isActive: 1,
        };
      });

      console.log("eventNewArr", eventNewArr);
      const updatedPhotoList = centerPhotoList.map((item) => ({
        CenterPhotoID: item.CenterPhotoID ? item.CenterPhotoID : null,
        FilePath: item.FilePath ? item.FilePath : null,
        fileName: item.fileName ? item.fileName : null,
        formFileType: item.formFileType ? item.formFileType : null,
        formFile: item.formFile ? item.formFile : null,
      }));

      const finalPriceList = priceList.map((item) => ({
        CenterPriceID: item.CenterPriceID ? item.CenterPriceID : 0,
        TimeslotID: item.TimeslotID,
        PriceINR: item.PriceINR,
        PriceUSD: item.PriceUSD,
        WithEffectFrom: item.WithEffectFrom,
        isActive: item.isActive,
      }))
      const finalSDList = SDList.map((item) => ({
        CenterSecurityDepositID: item.CenterSecurityDepositID ? item.CenterSecurityDepositID : 0,
        TimeSlotID: item.TimeSlotID,
        PriceInINR: item.PriceInINR,
        PriceInUSD: item.PriceInUSD,
        isActive: item.isActive == true ? 1 : 0,
      }))
      const finalSittingList = sittingList.map((item) => ({
        SittingTypeID: item.SittingTypeID, ID: item.ID ? item.ID : 0, IsActive: item.IsActive
      }))
      const finalInclusiveList = inclusiveList.map((item) => ({
        CenterServicesID: item.CenterServicesID ? item.CenterServicesID : 0,
        ServiceName: item.ServiceName,
        isActive: item.isActive
      }))
      const finalExternalList = externalList.map((item) => ({
        CenterServicesID: item.CenterServicesID ? item.CenterServicesID : 0,
        ServiceID: item.ServiceID,
        ServiceName: item.ServiceName,
        isActive: item.isActive
      }))
      console.log(inhouseList, "---------------");
      const finalInhouseList = inhouseList.map((item) => ({
        CenterAdditionalServiceID: item.CenterAdditionalServiceID ? item.CenterAdditionalServiceID : 0,
        AdditionalServiceID: item.AdditionalServiceID,
        ServiceType: item.ServiceType,
        MaxQuantity: item.MaxQuantity,
        ServiceDetails: item.ServiceDetails,
        Remark: item.Remark,
        StatusID: item.StatusID
      }));

      const finalInhouseSubList = [];

      inhouseList.forEach((item) => {
        finalInhouseSubList.push({
          CenterAdditionalServicePricingID: item.CenterAdditionalServicePricingID ? item.CenterAdditionalServicePricingID : 0,
          AdditionalServiceID: item.AdditionalServiceID,
          ServiceType: item.ServiceType,
          Quantity: item.Quantity,
          PriceInINR: item.PriceInINR,
          PriceInUSD: item.PriceInUSD,
          EffectiveDate: item.EffectiveDate,
          Isactive: item.StatusID == 1 ? 1 : 0
        });
      });

      const finalConsumableList = consumableList.map((item) => ({
        ConsumableID: item.ConsumableID, ID: item.ID ? item.ID : 0, isActive: item.isActive
      }))
      console.log(finalConsumableList, "finalConsumableList")

      const finalSecurityCheckList = securityChecklist.map((item) => ({
        CenterSecurityChecklistID: item.CenterSecurityChecklistID ? item.CenterSecurityChecklistID : 0,
        Name: item.Name,
        isClient: item.isClient,
        isActive: item.isActive
      }))

      console.log("finalInhouseList:", finalInhouseList);
      console.log("finalInhouseSubList:", finalInhouseSubList);

      const confirmed = window.confirm(
        `Are You sure you want to ${CenterID ? "Add" : "Update"} this Center`
      );
      if (confirmed) {
        this.setState({ isLoading: true });
        this.props
          .multi_purpose_centre_add_action(
            CenterID,
            Code,
            Name,
            AddressLine1,
            AddressLine2,
            CityID, // Use the extracted CityID
            StateID,
            Countryid,
            Pincode,
            URL,
            MaxPAX,
            Description,
            SecurityDepositPricingModel,
            AdditionalHourInr,
            AdditionalHourUsd,
            OvernightChargesInr,
            OvernightChargesUsd,
            eventNewArr,
            updatedPhotoList,
            finalPriceList,
            finalSDList,
            finalSittingList,
            finalInclusiveList,
            finalExternalList,
            finalInhouseList,
            finalInhouseSubList,
            finalConsumableList,
            finalSecurityCheckList,
            StatusID
          )
          .then((data) => {
            console.log(data, "insert");
            if (data.error === 0) {
              this.setState({ isLoading: false }, () => {
                toastSuccess(
                  CenterID
                    ? "Center Updated Successfully"
                    : "Center Added Successfully"
                );
                setTimeout(() => {
                  this.props.navigate("/multi_purpose_centre");
                }, 1000); // Adjust the delay time as needed
              });
            } else {
              if (
                data.msg == sessionExpireMessage ||
                data.msg == tokenInavlidMessage
              ) {
                //after session expire.....................
                sessionStorage.clear();
                this.props.navigate("/normalView");
                setTimeout(() => {
                  toastError(data.msg);
                }, 500);
              } else {
                toastError(data.msg || "An unknown error occurred.");
              }
            }
          })
          .catch((e) => {
            console.log(e);
            this.setState({ isLoading: false });
            toastError("An unexpected error occurred.");
          });
      }
    }
  }

  //inhouse
  modalClose() {
    this.setState({
      show: false,
      editIndex: "",
      inhouseDetails: {
        CenterAdditionalServiceID: "",
        AdditionalServiceID: "",
        ServiceType: "",
        MaxQuantity: "",
        ServiceDetails: "",
        Remark: "",
        Quantity: "",
        PriceInINR: "",
        PriceInUSD: "",
        EffectiveDate: "",
        CenterAdditionalServicePricingID: "",
        StatusID: 1,
        Isactive: 1,
      },
      // inhouseSubList: [],
      // inhouseSubDetails: {
      //   Quantity: "",
      //   PriceInINR: "",
      //   PriceInUSD: "",
      //   EffectiveDate: "",
      // },
    });
  }
  EditModal(index, data) {
    const { inhouseSubList } = this.state;

    // Extract the required properties from the data object
    var {
      AdditionalServiceID,
      CenterAdditionalServiceID,
      CenterAdditionalServicePricingID,
      MaxQuantity,
      EffectiveDate,
      PriceInINR,
      PriceInUSD,
      Quantity,
      Remark,
      ServiceDetails,
      ServiceType,
      StatusID,
      Isactive,
    } = data;
    var EffectiveDate =
      EffectiveDate != null ? moment(EffectiveDate, "YYYY-MM-DD").toDate() : "";
    console.log(data, "**********");

    // Update the state
    this.setState(
      {
        show: true,
        editIndex: index != null ? index : null,
        inhouseDetails: {
          AdditionalServiceID,
          CenterAdditionalServiceID,
          Remark,
          ServiceDetails,
          MaxQuantity,
          ServiceType,
          CenterAdditionalServicePricingID,
          EffectiveDate,
          PriceInINR,
          PriceInUSD,
          Quantity,
          StatusID,
          Isactive,
        },
      },
      () => {
        console.log(this.state.inhouseDetails, "edit modal Open"); // Check inhouseDetails after state update
      }
    );
  }

  openAddModal() {
    // Clear inhouseDetails and inhouseSubDetails
    this.setState({
      editIndex: "",
      inhouseDetails: {
        CenterAdditionalServiceID: "",
        AdditionalServiceID: "",
        ServiceType: "",
        MaxQuantity: "",
        ServiceDetails: "",
        Remark: "",
        Quantity: "",
        PriceInINR: "",
        PriceInUSD: "",
        EffectiveDate: "",
        CenterAdditionalServicePricingID: "",
        StatusID: 1,
        Isactive: 1,
      },

      show: true, // Set show to true to open the modal
    });
  }
  removeInhouseList(indexToRemove, CenterAdditionalServiceID) {
    const { inhouseList } = this.state;
    let updatedList;

    if (CenterAdditionalServiceID) {
      updatedList = inhouseList.map(row =>
        row.CenterAdditionalServiceID === CenterAdditionalServiceID
          ? { ...row, StatusID: 0, Isactive: 0 }
          : row
      );
    } else {
      updatedList = inhouseList.map((row, rowIndex) =>
        rowIndex === indexToRemove
          ? { ...row, StatusID: 0, Isactive: 0 }
          : row
      );
    }

    this.setState({ inhouseList: updatedList });
  }


  submitInHouse() {
    const { inhouseList, inhouseDetails } = this.state;
    // inhouseSubList
    if (
      inhouseDetails.AdditionalServiceID == "" ||
      inhouseDetails.AdditionalServiceID == null ||
      inhouseDetails.AdditionalServiceID == "select"
    ) {
      toastError("Please select Additional Service");
    } else if (
      inhouseDetails.ServiceType == "" ||
      inhouseDetails.ServiceType == null ||
      inhouseDetails.ServiceType == "select"
    ) {
      toastError("Please select Service Type");
    } else if (inhouseDetails.ServiceDetails == "") {
      toastError("Please Enter Service Details");
    } else if (inhouseDetails.MaxQuantity == "") {
      toastError("Please Enter Max Quantity");
    } else if (inhouseDetails.Quantity == "") {
      toastError("Please Enter Quantity");
    } else if (inhouseDetails.PriceInINR == "") {
      toastError("Please Enter INR Price");
    } else if (inhouseDetails.PriceInUSD == "") {
      toastError("Please Enter USD Price");
    } else if (inhouseDetails.EffectiveDate == "") {
      toastError("Please Enter Effective Date");
    } else {
      const updatedInhouseDetails = {
        CenterAdditionalServiceID: inhouseDetails.CenterAdditionalServiceID,
        AdditionalServiceID: inhouseDetails.AdditionalServiceID,
        ServiceType: inhouseDetails.ServiceType,
        MaxQuantity: inhouseDetails.MaxQuantity,
        ServiceDetails: inhouseDetails.ServiceDetails,
        Remark: inhouseDetails.Remark,
        Quantity: inhouseDetails.Quantity,
        PriceInINR: inhouseDetails.PriceInINR,
        PriceInUSD: inhouseDetails.PriceInUSD,
        EffectiveDate: inhouseDetails.EffectiveDate,
        CenterAdditionalServicePricingID:
          inhouseDetails.CenterAdditionalServicePricingID,
        StatusID: 1,
        Isactive: 1,
      };
      // const updatedInhouseDetails = {
      //   ...inhouseDetails
      // };

      const updatedInhouseList = [...inhouseList, updatedInhouseDetails];

      console.log("Updated inhouseList:", updatedInhouseList);

      this.setState({
        inhouseList: updatedInhouseList,
        show: false,
      });
    }
  }

  editInHouse(editIndex) {
    const { inhouseList, inhouseDetails } = this.state;
    // , inhouseSubList

    const updatedInhouseList = [...inhouseList];
    const existingInhouseDetails = updatedInhouseList[editIndex];
    existingInhouseDetails.CenterAdditionalServiceID =
      inhouseDetails.CenterAdditionalServiceID;
    existingInhouseDetails.AdditionalServiceID =
      inhouseDetails.AdditionalServiceID;
    existingInhouseDetails.ServiceType = inhouseDetails.ServiceType;
    existingInhouseDetails.MaxQuantity = inhouseDetails.MaxQuantity;
    existingInhouseDetails.ServiceDetails = inhouseDetails.ServiceDetails;
    existingInhouseDetails.Remark = inhouseDetails.Remark;

    existingInhouseDetails.CenterAdditionalServicePricingID =
      inhouseDetails.CenterAdditionalServicePricingID;
    existingInhouseDetails.PriceInINR = inhouseDetails.PriceInINR;
    existingInhouseDetails.PriceInUSD = inhouseDetails.PriceInUSD;
    existingInhouseDetails.Quantity = inhouseDetails.Quantity;
    existingInhouseDetails.EffectiveDate = inhouseDetails.EffectiveDate;
    existingInhouseDetails.StatusID = 1;
    existingInhouseDetails.Isactive = 1;

    // existingInhouseDetails.inhouseSubList = [...inhouseSubList];
    updatedInhouseList[editIndex] = existingInhouseDetails;
    console.log(updatedInhouseList, "updatedInhouseList");
    this.setState({
      inhouseList: updatedInhouseList,
      show: false,
    });
  }

  // handleDeleteInhouseSub(index) {
  //   const { inhouseSubList } = this.state;
  //   const updatedList = [...inhouseSubList];
  //   updatedList.splice(index, 1); // Remove the row at the specified index
  //   this.setState({
  //     inhouseSubList: updatedList,
  //   });
  // }

  render() {
    const {
      isLoading,
      show,
      stateList,
      CenterID,
      Name,
      Code,
      AddressLine1,
      AddressLine2,
      StateID,
      Countryid,
      URL,
      MaxPAX,
      Description,
      SecurityDepositPricingModel,
      TypeOfEventList,
      priceList,
      timeSlotList,
      AdditionalServicesID,
      ServiceType,
      ServiceDetails,
      Remark,
      Quantity,
      externalServiceFillList,
      PriceInINR,
      securityCheckFillList,
      PriceInUSD,
      EffectiveDate,
      AdditionalServiceID,
      showNewPriceRow,
      priceRowDetail,
      quantityFormList,
      additionalServiceFillList,
      sittingTypeFillList,
      consumableFillList,
      countryList,
      CityName,
      Pincode,
      cityList,
      CityID,
      AdditionalHourInr,
      AdditionalHourUsd,
      OvernightChargesInr,
      OvernightChargesUsd,
      EventName,
      centerPhotoList,
      showNewRow,
      showNewRowSitting,
      showNewRowInclusive,
      showNewRowExternal,
      showNewInhouseSub,
      inclusiveList,
      inclusiveDetails,
      ServiceName,
      externalList,
      externalDetails,
      ExternalServicesID,
      sittingList,
      sittingDetails,
      SittingType,
      editedRowIndexSitting,
      editedRowDataSitting,
      editedRowIndexInclusive,
      editedRowDataSecurityChecklist,
      editedRowDataInclusive,
      editedRowIndexExternal,
      editedSDRowData,
      editedSDRowIndex,
      showNewSDRow,
      editedRowDataExternal,
      editedRowIndexInhouseSub,
      editedRowDataInhouseSub,

      //inhouse
      inhouseSubList, inhouseDetails, inhouseList, inhouseSubDetails, editIndex,

      NameErr,
      address1Err,
      address2Err,
      cityErr,
      StateErr,
      countryErr,
      PincodeErr,
      urlErr,
      paxErr,
      eventListErr,
      SecurityDepositPricingModelErr,
      Status,
      SDList,
      SDRowDetail,
      extractedTimeSlotList,
      consumableDetails,
      consumableList,
      showNewRowConsumable,
      showNewRowSecurityChecklist,
      securityChecklistDetails,
      securityChecklist,
      editedRowDataConsumable,
      editedRowIndexConsumable,
      editedRowIndexSecurityChecklist,
      downloadUrl,
    } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[17]} />
            <section style={{ marginTop: 115 }}>
              <div class="container-fluid">
                <div class="page-header">
                  <h4 class="page-title">
                    {CenterID ? "Edit" : "Add"} Multi-Purpose Centre’s
                  </h4>
                  <div className="Service_display pt-2">
                    {console.log(Status, "Status")}
                    <h6 className="Services_Active_or_Not">
                      {CenterID
                        ? Status == "Active"
                          ? "Active"
                          : "InActive"
                        : "Active"}
                    </h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                        {CenterID ? (
                          <>
                            <input
                              type="checkbox"
                              checked={Status == "Active" ? 1 : 0}
                              onChange={() => {
                                if (Status == "Active") {
                                  this.setState({ Status: "InActive" });
                                } else {
                                  this.setState({ Status: "Active" });
                                }
                              }}
                            />
                            <span class="slider round"></span>
                          </>
                        ) : (
                          <>
                            <input type="checkbox" checked={1} />
                            <span class="slider round"></span>
                          </>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="card Service_fields">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Center Code</label>
                          <input
                            type="text"
                            value={Code}
                            disabled
                            // onChange={(e) =>
                            //   this.setState({ Code: e.target.value })
                            // }
                            class="form-control"
                            placeholder="Enter Center Code"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>
                            Center Name{" "}
                            <span className="mendatory_class">*</span>
                          </label>
                          <input
                            type="text"
                            value={Name}
                            onChange={(e) =>
                              this.setState({
                                Name: e.target.value,
                                NameErr: "",
                              })
                            }
                            class="form-control"
                            placeholder="Enter Center Name"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {NameErr}
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div className="form-group">
                          <label>
                            Security Deposit Pricing Model
                            <span className="mendatory_class">*</span>
                          </label>
                          <select
                            className="form-control search_form_control"
                            value={SecurityDepositPricingModel}
                            onChange={(e) =>
                              this.setState({
                                SecurityDepositPricingModel: e.target.value,
                                SecurityDepositPricingModelErr: "",
                              })
                            }
                          >
                            <option>Select</option>
                            <option value="Per Day">Per Day</option>
                            <option value="Per Order">Per Order</option>
                          </select>
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {SecurityDepositPricingModelErr}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>
                            Address Line 1{" "}
                            <span className="mendatory_class">*</span>
                          </label>
                          <input
                            type="text"
                            value={AddressLine1}
                            onChange={(e) =>
                              this.setState({
                                AddressLine1: e.target.value,
                                address1Err: "",
                              })
                            }
                            class="form-control"
                            placeholder="Enter Address Line 1"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {address1Err}
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>
                            Address Line 2{" "}
                            <span className="mendatory_class">*</span>
                          </label>
                          <input
                            type="text"
                            value={AddressLine2}
                            onChange={(e) =>
                              this.setState({
                                AddressLine2: e.target.value,
                                address2Err: "",
                              })
                            }
                            class="form-control"
                            placeholder="Enter Address Line 2"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {address2Err}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <div className="position-relative">
                            <label className="floating-label-outside">
                              City <span className="mendatory_class">*</span>
                            </label>
                            <select
                              id="country"
                              name="STATE"
                              value={this.state.CityID}
                              onChange={(e) => {
                                const selectedCityId = e.target.value;
                                console.log(
                                  "Selected City ID:",
                                  selectedCityId
                                );
                                // Make sure that the City is updated correctly
                                this.setState({
                                  CityID: selectedCityId,
                                  cityErr: "",
                                });
                              }}
                              className="form-control floating-control"
                            >
                              <option value="">SELECT CITY</option>
                              {cityList.length > 0 &&
                                cityList.map((data) => (
                                  <option key={data.City} value={data.Code}>
                                    {data.CityName}
                                  </option>
                                ))}
                            </select>
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {cityErr}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>
                            State <span className="mendatory_class">*</span>
                          </label>
                          <select
                            id="country"
                            name="STATE"
                            value={StateID}
                            onChange={(e) => {
                              const selectedStateId = e.target.value;
                              console.log(
                                "Selected State ID:",
                                selectedStateId
                              );
                              // Make sure that the state is updated correctly
                              this.setState({
                                StateID: selectedStateId,
                                StateErr: "",
                              });
                            }}
                            className="form-control floating-control"
                          >
                            <option value="">SELECT STATE</option>
                            {stateList.length > 0 &&
                              stateList.map((data) => (
                                <option key={data.Code} value={data.Code}>
                                  {data.Description}
                                </option>
                              ))}
                          </select>
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {StateErr}
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>
                            Country <span className="mendatory_class">*</span>
                          </label>
                          <select
                            id="country"
                            value={Countryid}
                            onChange={(e) => {
                              const selectedCountryid = e.target.value;
                              console.log(
                                "Selected State ID:",
                                selectedCountryid
                              );
                              // Make sure that the state is updated correctly
                              this.setState({
                                Countryid: selectedCountryid,
                                countryErr: "",
                              });
                            }}
                            className="form-control floating-control"
                          >
                            <option value="">SELECT COUNTRY</option>
                            {countryList.length > 0 &&
                              countryList.map((data) => (
                                <option
                                  key={data.Countryid}
                                  value={data.Countryid}
                                >
                                  {data.CountryName}
                                </option>
                              ))}
                          </select>
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {countryErr}
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>
                            Pincode <span className="mendatory_class">*</span>
                          </label>
                          <input
                            value={Pincode}
                            onChange={(e) =>
                              this.setState({
                                Pincode: e.target.value,
                                PincodeErr: "",
                              })
                            }
                            type="text"
                            class="form-control"
                            placeholder="Enter Pincode"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {PincodeErr}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>
                            URL <span className="mendatory_class">*</span>
                          </label>
                          <input
                            type="text"
                            value={URL}
                            onChange={(e) =>
                              this.setState({ URL: e.target.value, urlErr: "" })
                            }
                            class="form-control"
                            placeholder="Url"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {urlErr}
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>
                            Max PAX Allowed{" "}
                            <span className="mendatory_class">*</span>
                          </label>
                          <input
                            type="text"
                            value={MaxPAX}
                            onChange={(e) =>
                              this.setState({
                                MaxPAX: e.target.value,
                                paxErr: "",
                              })
                            }
                            class="form-control"
                            placeholder="Max PAX"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {paxErr}
                            </span>
                          }
                        </div>
                      </div>
                      <div className="col-md-6 form-group">
                        <label>
                          Type of Event{" "}
                          <span className="mendatory_class">*</span>
                        </label>
                        <Select
                          isMulti
                          value={EventName}
                          onChange={(e) =>
                            this.setState({ EventName: e, eventListErr: "" })
                          }
                          styles={customStyles}
                          options={TypeOfEventList}
                        />
                        {
                          <span className="text-danger text-start text-left d-block mt-1">
                            {eventListErr}
                          </span>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>
                            Additional Hour Charges (INR)  <span className="mendatory_class">*</span>
                          </label>
                          <input
                            type="text"
                            value={AdditionalHourInr}
                            onChange={(e) =>
                              this.setState({ AdditionalHourInr: e.target.value, AdditionalHourInrErr: "" })
                            }
                            class="form-control"
                            placeholder="Additional Hour (in Inr)"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {this.state.AdditionalHourInrErr}
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>
                            Additional Hour Charges (USD)  <span className="mendatory_class">*</span>
                          </label>
                          <input
                            type="text"
                            value={AdditionalHourUsd}
                            onChange={(e) =>
                              this.setState({ AdditionalHourUsd: e.target.value, AdditionalHourUsdErr: "" })
                            }
                            class="form-control"
                            placeholder="Additional Hour (in Usd)"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {this.state.AdditionalHourUsdErr}
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>
                            Overnight Charges (INR){" "}
                            <span className="mendatory_class">*</span>
                          </label>
                          <input
                            type="text"
                            value={OvernightChargesInr}
                            onChange={(e) =>
                              this.setState({
                                OvernightChargesInr: e.target.value,
                                OvernightChargesInrErr: "",
                              })
                            }
                            class="form-control"
                            placeholder="Overnight Charges (in Inr)"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {this.state.OvernightChargesInrErr}
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>
                            Overnight Charges (USD){" "}
                            <span className="mendatory_class">*</span>
                          </label>
                          <input
                            type="text"
                            value={OvernightChargesUsd}
                            onChange={(e) =>
                              this.setState({
                                OvernightChargesUsd: e.target.value,
                                OvernightChargesUsdErr: "",
                              })
                            }
                            class="form-control"
                            placeholder="Overnight Charges (in Usd)"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {this.state.OvernightChargesUsdErr}
                            </span>
                          }
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Descriptive / Description</label>
                          <textarea
                            value={Description}
                            onChange={(e) =>
                              this.setState({ Description: e.target.value })
                            }
                            class="form-control"
                            rows={3}
                            defaultValue={""}
                          />
                        </div>
                      </div>
                    </div>
                    {console.log(centerPhotoList)}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="upload__box">
                            <div className="upload__btn-box">
                              <label className="upload__btn">
                                <p>
                                  Upload Photos{" "}
                                  <span className="upload_size">
                                    ( Max 10 Photos, Max 2MB each )
                                  </span>
                                </p>
                                <input
                                  type="file"
                                  className="upload__inputfile"
                                  accept=".jpeg, .jpg, .png"
                                  onChange={this.handleFileChange}
                                  multiple
                                />
                              </label>
                            </div>
                            {this.renderPreview()}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div
                          class="card mb-3"
                          style={{ backgroundColor: "#f0f0f0" }}
                        >
                          <div class="card-body">
                            <label
                              style={{
                                fontWeight: 600,
                                fontSize: 13,
                                marginBottom: 5,
                                color: "#232323",
                              }}
                            >
                              Price
                            </label>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom_table">
                                  <div class="hack1">
                                    <div class="hack2">
                                      <table
                                        class="table table-bordered table-striped"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th>Timeslot</th>
                                            <th style={{ width: "30%" }}>
                                              Price (in INR)
                                            </th>
                                            <th style={{ width: "30%" }}>
                                              Price (in USD)
                                            </th>
                                            <th>With Effect From</th>
                                            <th
                                              class="text-right"
                                              style={{ width: "10%" }}
                                            >
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody id="myTable">
                                          {priceList.length > 0 ? (
                                            priceList
                                              .filter(
                                                (data) => data.isActive == 1)
                                              .map((data, index) => (
                                                <tr key={index}>
                                                  <td>
                                                    {this.state
                                                      .editedPriceRowIndex ===
                                                      index ? (
                                                      <select
                                                        className="form-control"
                                                        name="TimeSlot"
                                                        value={
                                                          priceRowDetail.TimeslotID ||
                                                          data.TimeSlotID
                                                        }
                                                        onChange={(e) => {
                                                          const selectedTimeslotID =
                                                            e.target.value; // This is the TimeslotID from the timeSlotList
                                                          this.setState({
                                                            priceRowDetail: {
                                                              ...priceRowDetail,
                                                              TimeslotID:
                                                                selectedTimeslotID,
                                                            },
                                                          });
                                                        }}
                                                      >
                                                        <option value="">
                                                          --Select--
                                                        </option>
                                                        {timeSlotList.map(
                                                          (data) => (
                                                            <option
                                                              key={data.TimeSlotID}
                                                              value={data.TimeSlotID}
                                                            >
                                                              {data.TimeSlotName} {data.TimeSlotName ? '-' : data.Slot ? '-' : ''} {data.Slot}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    ) : (
                                                      (() => {
                                                        const timeslot =
                                                          timeSlotList.find(
                                                            (item) =>
                                                              item.TimeSlotID ===
                                                              data.TimeslotID
                                                          );
                                                        return timeslot
                                                          ? `${timeslot.Slot != null ? timeslot.Slot : timeslot.TimeSlotName}`
                                                          : "";
                                                      })()
                                                    )}
                                                  </td>
                                                  <td>
                                                    {this.state
                                                      .editedPriceRowIndex ===
                                                      index ? (
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                          this.state
                                                            .editedPriceRowData
                                                            .PriceINR
                                                        }
                                                        onChange={(e) => {
                                                          const value =
                                                            e.target.value;

                                                          const numericValue =
                                                            value
                                                              .replace(
                                                                /[^0-9.]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /(\..*)\./g,
                                                                "$1"
                                                              );
                                                          this.handlePriceRowEditFieldChange(
                                                            index,
                                                            "PriceINR",
                                                            numericValue
                                                          );
                                                        }}
                                                      />
                                                    ) : (
                                                      data.PriceINR.toLocaleString(
                                                        "en-IN"
                                                      )
                                                    )}
                                                  </td>
                                                  <td>
                                                    {this.state
                                                      .editedPriceRowIndex ===
                                                      index ? (
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                          this.state
                                                            .editedPriceRowData
                                                            .PriceUSD
                                                        }
                                                        onChange={(e) => {
                                                          const value =
                                                            e.target.value;

                                                          const numericValue =
                                                            value
                                                              .replace(
                                                                /[^0-9.]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /(\..*)\./g,
                                                                "$1"
                                                              );
                                                          this.handlePriceRowEditFieldChange(
                                                            index,
                                                            "PriceUSD",
                                                            numericValue
                                                          );
                                                        }}
                                                      />
                                                    ) : (
                                                      data.PriceUSD.toLocaleString(
                                                        "en-IN"
                                                      )
                                                    )}
                                                  </td>
                                                  <td>
                                                    {this.state
                                                      .editedPriceRowIndex ===
                                                      index ? (
                                                      <DatePicker
                                                        className="form-control"
                                                        dateFormat="dd-MM-yyyy"
                                                        selected={
                                                          this.state
                                                            .editedPriceRowData
                                                            .WithEffectFrom
                                                            ? new Date(
                                                              this.state.editedPriceRowData.WithEffectFrom
                                                            )
                                                            : null
                                                        }
                                                        onChange={(e) =>
                                                          this.handlePriceRowEditFieldChange(
                                                            index,
                                                            "WithEffectFrom",
                                                            e
                                                          )
                                                        }
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        placeholderText="WithEffectFrom"
                                                        customInput={
                                                          <CustomInput />
                                                        }
                                                        dayClassName={() =>
                                                          "example-datepicker-day-class"
                                                        }
                                                        popperClassName="example-datepicker-class"
                                                      />
                                                    ) : (
                                                      data.WithEffectFrom &&
                                                      new Date(
                                                        data.WithEffectFrom
                                                      ).toLocaleDateString(
                                                        "en-GB",
                                                        {
                                                          day: "2-digit",
                                                          month: "2-digit",
                                                          year: "numeric",
                                                        }
                                                      )
                                                    )}
                                                  </td>
                                                  <td className="text-right">
                                                    {this.state
                                                      .editedPriceRowIndex ===
                                                      index ? (
                                                      <>
                                                        <a
                                                          title="Save"
                                                          className="btn btn-sm padding_0"
                                                          onClick={() =>
                                                            this.saveEditedPriceRow(
                                                              index
                                                            )
                                                          }
                                                        >
                                                          <i className="fa fa-save action_btn_table" />
                                                        </a>
                                                        <a
                                                          title="Cancel"
                                                          className="btn btn-sm padding_0"
                                                          onClick={() =>
                                                            this.cancelEditPriceRow()
                                                          }
                                                        >
                                                          <i className="fa fa-times action_btn_table" />
                                                        </a>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <a
                                                          title="Edit"
                                                          className="btn btn-sm padding_0"
                                                          onClick={() =>
                                                            this.handleEditPriceRow(
                                                              index,
                                                              data
                                                            )
                                                          }
                                                        >
                                                          <i className="fa fa-edit action_btn_table" />
                                                        </a>
                                                        <a
                                                          title="Delete"
                                                          className="btn btn-sm delete_record padding_0"
                                                          onClick={() =>
                                                            this.handleDeletePriceRow(
                                                              index
                                                            )
                                                          }
                                                        >
                                                          <i className="fa fa-trash action_btn_table" />
                                                        </a>
                                                      </>
                                                    )}
                                                  </td>
                                                </tr>
                                              ))
                                          ) : (
                                            <tr>
                                              <td colSpan="10">
                                                No data available.
                                              </td>
                                            </tr>
                                          )}
                                          {showNewPriceRow && (
                                            <tr>
                                              <td>
                                                <select
                                                  className="form-control"
                                                  name="TimeSlot"
                                                  value={
                                                    priceRowDetail.TimeslotID
                                                  }
                                                  onChange={(e) => {
                                                    const selectedTimeslotID =
                                                      e.target.value; // This is the TimeslotID from the timeSlotList
                                                    this.setState({
                                                      priceRowDetail: {
                                                        ...priceRowDetail,
                                                        TimeslotID:
                                                          selectedTimeslotID,
                                                      },
                                                    });
                                                  }}
                                                >
                                                  <option value="">
                                                    --Select--
                                                  </option>
                                                  {timeSlotList.map((data) => (
                                                    <option
                                                      key={data.TimeSlotID}
                                                      value={data.TimeSlotID}
                                                    >
                                                      {data.TimeSlotName} - {data.Slot}
                                                    </option>
                                                  ))}
                                                </select>
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="name"
                                                  className="form-control"
                                                  value={
                                                    priceRowDetail.PriceINR
                                                  }
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value;

                                                    const numericValue = value
                                                      .replace(/[^0-9.]/g, "")
                                                      .replace(
                                                        /(\..*)\./g,
                                                        "$1"
                                                      );
                                                    this.setState({
                                                      priceRowDetail: {
                                                        ...priceRowDetail,
                                                        PriceINR: numericValue,
                                                      },
                                                    });
                                                  }}
                                                  placeholder="PriceINR"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="name"
                                                  className="form-control"
                                                  value={
                                                    priceRowDetail.PriceUSD
                                                  }
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value;

                                                    const numericValue = value
                                                      .replace(/[^0-9.]/g, "")
                                                      .replace(
                                                        /(\..*)\./g,
                                                        "$1"
                                                      );
                                                    this.setState({
                                                      priceRowDetail: {
                                                        ...priceRowDetail,
                                                        PriceUSD: numericValue,
                                                      },
                                                    });
                                                  }}
                                                  placeholder="PriceUSD"
                                                />
                                              </td>
                                              <td>
                                                <DatePicker
                                                  className="form-control"
                                                  dateFormat="dd-MM-yyyy"
                                                  selected={
                                                    priceRowDetail.WithEffectFrom
                                                  }
                                                  onChange={(e) =>
                                                    this.setState({
                                                      priceRowDetail: {
                                                        ...priceRowDetail,
                                                        WithEffectFrom: e,
                                                      },
                                                    })
                                                  }
                                                  peekNextMonth
                                                  showMonthDropdown
                                                  showYearDropdown
                                                  dropdownMode="select"
                                                  placeholderText="WithEffectFrom"
                                                  customInput={<CustomInput />}
                                                  dayClassName={() =>
                                                    "example-datepicker-day-class"
                                                  }
                                                  popperClassName="example-datepicker-class"
                                                />
                                              </td>
                                              <td>
                                                <button
                                                  className="btn btn-primary btn-md"
                                                  onClick={() =>
                                                    this.handleAddRowPrice()
                                                  }
                                                >
                                                  Add
                                                </button>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                      <div>
                                        <a
                                          href="javascript:void(0);"
                                          class="btn btn-primary btn-sm create_btn add_additional_days_btn mb-3"
                                          style={{ width: "auto" }}
                                          onClick={() =>
                                            this.toggleNewPriceRow()
                                          }
                                        >
                                          <span class="hidden-xs">
                                            {showNewPriceRow ? "Cancel" : "Add"}
                                          </span>
                                        </a>
                                        {/* <button type="button" class="delete-row">Delete Row</button> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div
                          class="card mb-3"
                          style={{ backgroundColor: "#f0f0f0" }}
                        >
                          <div class="card-body">
                            <label
                              style={{
                                fontWeight: 600,
                                fontSize: 13,
                                marginBottom: 5,
                                color: "#232323",
                              }}
                            >
                              Security Deposit
                            </label>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom_table">
                                  <div class="hack1">
                                    <div class="hack2">
                                      <table
                                        class="table table-bordered table-striped"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th>Timeslot</th>
                                            <th style={{ width: "30%" }}>
                                              Price (in INR)
                                            </th>
                                            <th style={{ width: "30%" }}>
                                              Price (in USD)
                                            </th>

                                            <th
                                              class="text-right"
                                              style={{ width: "10%" }}
                                            >
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody id="myTable">
                                          {SDList.length > 0 ? (
                                            SDList.filter(
                                              (data) => data.isActive == 1
                                            ).map((data, index) => (
                                              <tr key={index}>
                                                <td>
                                                  {this.state
                                                    .editedSDRowIndex ===
                                                    index ? (
                                                    <select
                                                      className="form-control"
                                                      name="TimeSlot"
                                                      value={
                                                        SDRowDetail.TimeSlotID ||
                                                        data.TimeSlotID
                                                      }
                                                      onChange={(e) => {
                                                        const selectedTimeslotID =
                                                          e.target.value;
                                                        this.setState({
                                                          SDRowDetail: {
                                                            ...SDRowDetail,
                                                            TimeSlotID:
                                                              selectedTimeslotID,
                                                          },
                                                        });
                                                      }}
                                                    >
                                                      <option value="">
                                                        --Select--
                                                      </option>
                                                      {timeSlotList.map(
                                                        (data) => (
                                                          <option
                                                            key={data.TimeSlotID}
                                                            value={data.TimeSlotID}
                                                          >
                                                            {data.TimeSlotName} {data.TimeSlotName ? '-' : data.Slot ? '-' : ''} {data.Slot}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                  ) : (
                                                    (() => {
                                                      const timeslot =
                                                        timeSlotList.find(
                                                          (item) =>
                                                            item.TimeSlotID ===
                                                            data.TimeSlotID
                                                        );
                                                      return timeslot
                                                        ? `${timeslot.Slot != null ? timeslot.Slot : timeslot.TimeSlotName}`
                                                        : "";
                                                    })()
                                                  )}
                                                </td>
                                                <td>
                                                  {this.state
                                                    .editedSDRowIndex ===
                                                    index ? (
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={
                                                        this.state
                                                          .editedSDRowData
                                                          .PriceInINR
                                                      }
                                                      onChange={(e) => {
                                                        const value =
                                                          e.target.value;
                                                        const numericValue =
                                                          value
                                                            .replace(
                                                              /[^0-9.]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /(\..*)\./g,
                                                              "$1"
                                                            );
                                                        this.handleSDRowEditFieldChange(
                                                          index,
                                                          "PriceInINR",
                                                          numericValue
                                                        );
                                                      }}
                                                    />
                                                  ) : (
                                                    data.PriceInINR.toLocaleString(
                                                      "en-IN"
                                                    )
                                                  )}
                                                </td>
                                                <td>
                                                  {this.state
                                                    .editedSDRowIndex ===
                                                    index ? (
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      value={
                                                        this.state
                                                          .editedSDRowData
                                                          .PriceInUSD
                                                      }
                                                      onChange={(e) => {
                                                        const value =
                                                          e.target.value;
                                                        const numericValue =
                                                          value
                                                            .replace(
                                                              /[^0-9.]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /(\..*)\./g,
                                                              "$1"
                                                            );
                                                        this.handleSDRowEditFieldChange(
                                                          index,
                                                          "PriceInUSD",
                                                          numericValue
                                                        );
                                                      }}
                                                    />
                                                  ) : (
                                                    data.PriceInUSD.toLocaleString(
                                                      "en-IN"
                                                    )
                                                  )}
                                                </td>
                                                <td className="text-right">
                                                  {this.state
                                                    .editedSDRowIndex ===
                                                    index ? (
                                                    <>
                                                      <a
                                                        title="Save"
                                                        className="btn btn-sm padding_0"
                                                        onClick={() =>
                                                          this.saveEditedSDRow(
                                                            index
                                                          )
                                                        }
                                                      >
                                                        <i className="fa fa-save action_btn_table" />
                                                      </a>
                                                      <a
                                                        title="Cancel"
                                                        className="btn btn-sm padding_0"
                                                        onClick={() =>
                                                          this.cancelEditSDRow()
                                                        }
                                                      >
                                                        <i className="fa fa-times action_btn_table" />
                                                      </a>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <a
                                                        title="Edit"
                                                        className="btn btn-sm padding_0"
                                                        onClick={() =>
                                                          this.handleEditSDRow(
                                                            index,
                                                            data
                                                          )
                                                        }
                                                      >
                                                        <i className="fa fa-edit action_btn_table" />
                                                      </a>
                                                      <a
                                                        title="Delete"
                                                        className="btn btn-sm delete_record padding_0"
                                                        onClick={() =>
                                                          this.handleDeleteSDRow(
                                                            index
                                                          )
                                                        }
                                                      >
                                                        <i className="fa fa-trash action_btn_table" />
                                                      </a>
                                                    </>
                                                  )}
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td colSpan="10">
                                                No data available.
                                              </td>
                                            </tr>
                                          )}

                                          {showNewSDRow && (
                                            <tr>
                                              <td>
                                                <select
                                                  className="form-control"
                                                  name="TimeSlot"
                                                  value={SDRowDetail.TimeSlotID}
                                                  onChange={(e) => {
                                                    const selectedTimeslotID =
                                                      e.target.value;
                                                    this.setState({
                                                      SDRowDetail: {
                                                        ...SDRowDetail,
                                                        TimeSlotID:
                                                          selectedTimeslotID,
                                                      },
                                                    });
                                                  }}
                                                >
                                                  <option value="">
                                                    --Select--
                                                  </option>
                                                  {timeSlotList.map((data) => (
                                                    <option
                                                      key={data.TimeSlotID}
                                                      value={data.TimeSlotID}
                                                    >
                                                      {data.TimeSlotName} - {data.Slot}
                                                    </option>
                                                  ))}
                                                </select>
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="name"
                                                  className="form-control"
                                                  value={SDRowDetail.PriceInINR}
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value;

                                                    const numericValue = value
                                                      .replace(/[^0-9.]/g, "")
                                                      .replace(
                                                        /(\..*)\./g,
                                                        "$1"
                                                      );
                                                    this.setState({
                                                      SDRowDetail: {
                                                        ...SDRowDetail,
                                                        PriceInINR:
                                                          numericValue,
                                                      },
                                                    });
                                                  }}
                                                  placeholder="PriceINR"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="name"
                                                  className="form-control"
                                                  value={SDRowDetail.PriceInUSD}
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value;

                                                    const numericValue = value
                                                      .replace(/[^0-9.]/g, "")
                                                      .replace(
                                                        /(\..*)\./g,
                                                        "$1"
                                                      );
                                                    this.setState({
                                                      SDRowDetail: {
                                                        ...SDRowDetail,
                                                        PriceInUSD:
                                                          numericValue,
                                                      },
                                                    });
                                                  }}
                                                  placeholder="PriceUSD"
                                                />
                                              </td>

                                              <td>
                                                <button
                                                  className="btn btn-primary btn-md"
                                                  onClick={() =>
                                                    this.handleAddRowSD()
                                                  }
                                                >
                                                  Add
                                                </button>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                      <div>
                                        <a
                                          href="javascript:void(0);"
                                          class="btn btn-primary btn-sm create_btn add_additional_days_btn mb-3"
                                          style={{ width: "auto" }}
                                          onClick={() => this.toggleNewSDRow()}
                                        >
                                          <span class="hidden-xs">
                                            {showNewSDRow ? "Cancel" : "Add"}
                                          </span>
                                        </a>
                                        {/* <button type="button" class="delete-row">Delete Row</button> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div
                          class="card mb-3"
                          style={{ backgroundColor: "#f0f0f0" }}
                        >
                          <div class="card-body">
                            <label
                              style={{
                                fontWeight: 600,
                                fontSize: 13,
                                marginBottom: 5,
                                color: "#232323",
                              }}
                            >
                              Seating Type
                            </label>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom_table">
                                  <div class="hack1">
                                    <div class="hack2">
                                      <table
                                        class="table table-bordered table-striped"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10%" }}>
                                              Sr. no
                                            </th>
                                            <th style={{ width: "80%" }}>
                                              Seating Type
                                            </th>
                                            <th
                                              class="text-right"
                                              style={{ width: "10%" }}
                                            >
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody id="myTable">
                                          {sittingList.length > 0 ? (
                                            sittingList
                                              .filter(
                                                (data) => data.IsActive == 1)
                                              .map((data, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    {editedRowIndexSitting ===
                                                      index ? (
                                                      <select
                                                        className="form-control"
                                                        name="External Services"
                                                        value={sittingDetails.SittingTypeID || data.SittingTypeID}
                                                        onChange={(e) => {
                                                          const selectedExternalServicesID = e.target.value;
                                                          this.setState({
                                                            sittingDetails: {
                                                              ...sittingDetails,
                                                              SittingTypeID: selectedExternalServicesID,
                                                            },
                                                          });
                                                        }}
                                                      >
                                                        <option value="">--Select--</option>
                                                        {sittingTypeFillList.map(
                                                          (data) => (
                                                            <option key={data.SittingTypeID} value={data.SittingTypeID}>{data.Name}</option>
                                                          )
                                                        )}
                                                      </select>
                                                    ) : (
                                                      (() => {
                                                        const sittingTypeData = sittingTypeFillList.find(
                                                          (item) => item.SittingTypeID == data.SittingTypeID);
                                                        return sittingTypeData ? `${sittingTypeData.Name}` : "";
                                                      })()
                                                    )}
                                                  </td>
                                                  <td className="text-right">
                                                    {editedRowIndexSitting === index ? (
                                                      <>
                                                        <a title="Save" className="btn btn-sm padding_0"
                                                          onClick={() => this.saveEditedRowSitting(index)}
                                                        ><i className="fa fa-save action_btn_table" />
                                                        </a>
                                                        <a title="Cancel" className="btn btn-sm padding_0"
                                                          onClick={() => this.cancelEditRowSitting()}
                                                        ><i className="fa fa-times action_btn_table" />
                                                        </a>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <a title="Edit" className="btn btn-sm padding_0"
                                                          onClick={() => this.handleEditRowSitting(index, data)}
                                                        ><i className="fa fa-edit action_btn_table" />
                                                        </a>
                                                        <a title="Delete" className="btn btn-sm delete_record padding_0"
                                                          onClick={() => this.handleDeleteRowSitting(index, data.SittingTypeID)}
                                                        ><i className="fa fa-trash action_btn_table" />
                                                        </a>
                                                      </>
                                                    )}
                                                  </td>
                                                </tr>
                                              ))
                                          ) : (
                                            <tr>
                                              <td colSpan="3">
                                                No data available.
                                              </td>
                                            </tr>
                                          )}
                                          {showNewRowSitting && (
                                            <tr>
                                              <td></td>
                                              <td>
                                                <select className="form-control"
                                                  name="External Services"
                                                  value={sittingDetails.SittingTypeID || data.ConsumableID}
                                                  onChange={(e) => {
                                                    const selectedExternalServicesID = e.target.value;
                                                    this.setState({
                                                      sittingDetails: {
                                                        ...sittingDetails,
                                                        SittingTypeID: selectedExternalServicesID,
                                                      },
                                                    });
                                                  }}>
                                                  <option value="">--Select--</option>
                                                  {sittingTypeFillList.map((data) => (
                                                    <option key={data.SittingTypeID}
                                                      value={data.SittingTypeID}
                                                    >{data.Name}
                                                    </option>
                                                  )
                                                  )}
                                                </select>
                                              </td>
                                              <td>
                                                <button className="btn btn-primary btn-md"
                                                  onClick={() => this.handleAddRowSitting()}>Add</button>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                      <div>
                                        <a href="javascript:void(0);"
                                          class="btn btn-primary btn-sm create_btn add_additional_days_btn mb-3"
                                          style={{ width: "auto" }}
                                          onClick={() => this.toggleNewRowSitting()}>
                                          <span class="hidden-xs">
                                            {showNewRowSitting ? "Cancel" : "Add"}
                                          </span>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="card mb-3" style={{ backgroundColor: "#f0f0f0" }}>
                          <div class="card-body">
                            <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 5, color: "#232323", }}>
                              Consumables
                            </label>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom_table">
                                  <div class="hack1">
                                    <div class="hack2">
                                      <table class="table table-bordered table-striped" id="tbl">
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10%" }}>
                                              Sr. no
                                            </th>
                                            <th style={{ width: "80%" }}>
                                              Consumable Name
                                            </th>
                                            <th class="text-right"
                                              style={{ width: "10%" }}
                                            >Action</th>
                                          </tr>
                                        </thead>
                                        <tbody id="myTable">
                                          {consumableList.length > 0 ? (consumableList.filter((data) => data.isActive == 1)
                                            .map((data, index) => (
                                              <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{editedRowIndexConsumable ===
                                                  index ? (
                                                  <select className="form-control"
                                                    name="External Services"
                                                    value={consumableDetails.ConsumableID || data.ConsumableID}
                                                    onChange={(e) => {
                                                      const selectedExternalServicesID = e.target.value;
                                                      this.setState({
                                                        consumableDetails: {
                                                          ...consumableDetails,
                                                          ConsumableID: selectedExternalServicesID,
                                                        },
                                                      });
                                                    }}>
                                                    <option value="">--Select--</option>
                                                    {consumableFillList.map((data) => (
                                                      <option key={data.ConsumableID}
                                                        value={data.ConsumableID}>
                                                        {data.ConsumableName}
                                                      </option>)
                                                    )}
                                                  </select>
                                                ) : (
                                                  (() => {
                                                    const consumableData =
                                                      consumableFillList.find((item) => item.ConsumableID == data.ConsumableID);
                                                    return consumableData ? `${consumableData.ConsumableName}` : "";
                                                  })()
                                                )}
                                                </td>
                                                <td className="text-right">
                                                  {editedRowIndexConsumable ===
                                                    index ? (
                                                    <>
                                                      <a title="Save" className="btn btn-sm padding_0"
                                                        onClick={() => this.saveEditedRowConsumable(index)}>
                                                        <i className="fa fa-save action_btn_table" />
                                                      </a>
                                                      <a title="Cancel"
                                                        className="btn btn-sm padding_0"
                                                        onClick={() => this.cancelEditRowConsumable()}
                                                      >
                                                        <i className="fa fa-times action_btn_table" />
                                                      </a>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <a title="Edit" className="btn btn-sm padding_0"
                                                        onClick={() => this.handleEditRowConsumable(index, data)}>
                                                        <i className="fa fa-edit action_btn_table" />
                                                      </a>
                                                      <a title="Delete" className="btn btn-sm delete_record padding_0"
                                                        onClick={() => this.handleDeleteRowConsumable(index, data.ConsumableID)}>
                                                        <i className="fa fa-trash action_btn_table" />
                                                      </a>
                                                    </>
                                                  )}
                                                </td>
                                              </tr>
                                            ))) : (
                                            <tr>
                                              <td colSpan="3">No data available.</td>
                                            </tr>
                                          )}
                                          {showNewRowConsumable && (
                                            <tr>
                                              <td></td>
                                              <td>
                                                <select className="form-control"
                                                  name="Consumable"
                                                  value={consumableDetails.ConsumableID || data.ConsumableID}
                                                  onChange={(e) => {
                                                    const selectedConsumableID = e.target.value;
                                                    this.setState({
                                                      consumableDetails: {
                                                        ...consumableDetails,
                                                        ConsumableID: selectedConsumableID,
                                                      },
                                                    });
                                                  }}>
                                                  <option value="">--Select--</option>
                                                  {consumableFillList.map(
                                                    (data) => (
                                                      <option key={data.ConsumableID}
                                                        value={data.ConsumableID}>
                                                        {data.ConsumableName}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </td>
                                              <td>
                                                <button className="btn btn-primary btn-md"
                                                  onClick={() => this.handleAddRowConsumable()}>
                                                  Add
                                                </button>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                      <div>
                                        <a href="javascript:void(0);"
                                          class="btn btn-primary btn-sm create_btn add_additional_days_btn mb-3"
                                          style={{ width: "auto" }}
                                          onClick={() => this.toggleNewRowConsumable()}
                                        >
                                          <span class="hidden-xs">
                                            {showNewRowConsumable ? "Cancel" : "Add"}
                                          </span>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="card mb-3" style={{ backgroundColor: "#f0f0f0" }}>
                          <div class="card-body">
                            <label style={{
                              fontWeight: 600,
                              fontSize: 13,
                              marginBottom: 5,
                              color: "#232323",
                            }}
                            >Inclusive Services</label>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom_table">
                                  <div class="hack1">
                                    <div class="hack2">
                                      <table class="table table-bordered table-striped" id="tbl">
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10%" }}>
                                              Sr. no
                                            </th>
                                            <th style={{ width: "80%" }}>
                                              Service Name
                                            </th>
                                            <th
                                              class="text-right"
                                              style={{ width: "10%" }}
                                            >
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody id="myTable">
                                          {inclusiveList.length > 0 ? (inclusiveList.filter((data) => data.isActive == 1)
                                            .map((data, index) => (
                                              <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                  {editedRowIndexInclusive === index ? (
                                                    <input type="text" className="form-control"
                                                      value={editedRowDataInclusive.ServiceName}
                                                      onChange={(e) => this.handleRowEditFieldChangeInclusive(index, "ServiceName", e.target.value)} />
                                                  ) : (data.ServiceName)}
                                                </td>
                                                <td className="text-right">
                                                  {editedRowIndexInclusive === index ? (
                                                    <>
                                                      <a title="Save" className="btn btn-sm padding_0"
                                                        onClick={() => this.saveEditedRowInclusive(index)}
                                                      ><i className="fa fa-save action_btn_table" />
                                                      </a>
                                                      <a title="Cancel" className="btn btn-sm padding_0"
                                                        onClick={() => this.cancelEditRowInclusive()}>
                                                        <i className="fa fa-times action_btn_table" />
                                                      </a>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <a title="Edit" className="btn btn-sm padding_0"
                                                        onClick={() => this.handleEditRowInclusive(index, data)}
                                                      ><i className="fa fa-edit action_btn_table" />
                                                      </a>
                                                      <a title="Delete" className="btn btn-sm delete_record padding_0"
                                                        onClick={() => this.handleDeleteRowInclusive(index, data.CenterServicesID)}>
                                                        <i className="fa fa-trash action_btn_table" />
                                                      </a>
                                                    </>
                                                  )}
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td colSpan="3">
                                                No data available.
                                              </td>
                                            </tr>
                                          )}
                                          {showNewRowInclusive && (
                                            <tr>
                                              <td></td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="name"
                                                  className="form-control"
                                                  value={inclusiveDetails.ServiceName}
                                                  onChange={(e) =>
                                                    this.setState({
                                                      inclusiveDetails: {
                                                        ...inclusiveDetails,
                                                        ServiceName: e.target.value,
                                                      },
                                                    })
                                                  } placeholder="Service Name" /></td>
                                              <td>
                                                <button className="btn btn-primary btn-md"
                                                  onClick={() => this.handleAddRowInclusive()}>Add</button>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                      <div>
                                        <a href="javascript:void(0);"
                                          class="btn btn-primary btn-sm create_btn add_additional_days_btn mb-3"
                                          style={{ width: "auto" }}
                                          onClick={() => this.toggleNewRowInclusive()}>
                                          <span class="hidden-xs">
                                            {showNewRowInclusive ? "Cancel" : "Add"}
                                          </span>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="card" style={{ backgroundColor: "#f0f0f0" }}>
                          <div class="card-body">
                            <label
                              style={{
                                fontWeight: 600,
                                fontSize: 13,
                                marginBottom: 5,
                                color: "#232323",
                              }}
                            >In-House Paid Services</label>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom_table">
                                  <div class="hack1">
                                    <div class="hack2">
                                      <table className="table table-bordered table-striped" id="dashboard-table">
                                        <thead>
                                          <tr>
                                            <th>Sr. No</th>
                                            <th>Services</th>
                                            <th>Type</th>
                                            <th>Max Quantity</th>
                                            <th>Service Details</th>
                                            <th>Quantity</th>
                                            <th>Price (in INR)</th>
                                            <th>Price (in USD)</th>
                                            <th>Date</th>
                                            <th>Remark</th>
                                            <th className="text-right">Action</th>
                                          </tr>
                                        </thead>
                                        <tbody id="myTable">
                                          {inhouseList.length > 0 ? (inhouseList.filter((data) => data.StatusID == 1)
                                            .map((data, index) => (
                                              <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                  {additionalServiceFillList.find((service) =>
                                                    service.AdditionalServicesID === parseInt(data.AdditionalServiceID)
                                                  )?.Name || data.AdditionalServiceID}
                                                </td>
                                                <td>{data.ServiceType}</td>
                                                <td className="text-center">{data.MaxQuantity}</td>
                                                <td>{data.ServiceDetails}</td>
                                                <td className="text-center">{data.Quantity ? data.Quantity : ""}</td>
                                                <td>{data.PriceInINR ? data.PriceInINR : ""}</td>
                                                <td>{data.PriceInUSD ? data.PriceInUSD : ""}</td>
                                                <td>{data.EffectiveDate != "" ? moment(data.EffectiveDate).format("DD-MM-YYYY") : ""}</td>
                                                <td>{data.Remark}</td>
                                                <td className="text-right">
                                                  <a href="javascript:void(0);" title="Edit" className="btn btn-sm">
                                                    <i className="fa fa-edit action_btn_table"
                                                      onClick={() => this.EditModal(index, data)}
                                                    ></i>
                                                  </a>
                                                  <a title="Delete" className="btn btn-sm delete_record"
                                                    onClick={() => this.removeInhouseList(index, data.CenterAdditionalServiceID)}
                                                  ><i className="fa fa-trash action_btn_table"></i>
                                                  </a>
                                                </td>
                                                {/* {console.log(data.inhouseSubList[0])} */}
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td colSpan="12">
                                                No Data Available
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <div>
                                        <Button
                                          style={{
                                            background: "#35B3E6",
                                            border: "none",
                                            fontWeight: "400",
                                          }}
                                          onClick={() => this.openAddModal()}
                                        >
                                          Add
                                        </Button>
                                        {/* <button type="button" class="delete-row">Delete Row</button> */}
                                      </div>
                                      <Modal
                                        show={show}
                                        // onHide={this.modalClose}
                                        size="lg"
                                      >
                                        <Modal.Header>
                                          <Modal.Title>
                                            In-House Paid Services
                                          </Modal.Title>
                                          <span
                                            onClick={() => this.modalClose()}
                                            style={{
                                              cursor: "pointer",
                                              fontWeight: "800",
                                            }}
                                          >
                                            X
                                          </span>
                                        </Modal.Header>
                                        <Modal.Body>
                                          <div className="modal-body">
                                            <div className="row">
                                              <div className="col-md-4">
                                                <div className="form-group">
                                                  <label>
                                                    Services{" "}
                                                    <span className="mendatory_class">
                                                      *
                                                    </span>
                                                  </label>
                                                  <select
                                                    className="form-control"
                                                    value={
                                                      inhouseDetails.AdditionalServiceID
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        inhouseDetails: {
                                                          ...inhouseDetails,
                                                          AdditionalServiceID:
                                                            e.target.value,
                                                        },
                                                      })
                                                    }
                                                  >
                                                    <option value="">
                                                      --select--
                                                    </option>
                                                    {additionalServiceFillList.length >
                                                      0 &&
                                                      additionalServiceFillList.map(
                                                        (data) => (
                                                          <option
                                                            key={
                                                              data.AdditionalServicesID
                                                            }
                                                            value={
                                                              data.AdditionalServicesID
                                                            }
                                                          >
                                                            {data.Name}
                                                          </option>
                                                        )
                                                      )}
                                                  </select>
                                                </div>
                                              </div>
                                              <div className="col-md-4">
                                                <div className="form-group">
                                                  <label>
                                                    Service Type{" "}
                                                    <span className="mendatory_class">
                                                      *
                                                    </span>
                                                  </label>
                                                  <select
                                                    className="form-control"
                                                    value={
                                                      inhouseDetails.ServiceType
                                                    }
                                                    onChange={(e) => {
                                                      const newPackage =
                                                        e.target.value
                                                          .charAt(0)
                                                          .toUpperCase() +
                                                        e.target.value.slice(1);
                                                      const serviceIDCheck =
                                                        inhouseDetails.AdditionalServiceID;
                                                      const serviceTypeCheck =
                                                        inhouseDetails.ServiceType;

                                                      if (
                                                        inhouseList.find(
                                                          (data) =>
                                                            data.AdditionalServiceID ===
                                                            newPackage &&
                                                            data.City ===
                                                            serviceTypeCheck &&
                                                            data.ServiceType ==
                                                            serviceIDCheck
                                                        )
                                                      ) {
                                                        toastError(
                                                          "Service already exists",
                                                          {
                                                            position:
                                                              "top-center",
                                                            autoClose: 5000,
                                                            hideProgressBar: false,
                                                          }
                                                        );
                                                      } else {
                                                        this.setState({
                                                          inhouseDetails: {
                                                            ...inhouseDetails,
                                                            ServiceType:
                                                              e.target.value,
                                                          },
                                                        });
                                                      }
                                                    }}
                                                  >
                                                    <option value="">
                                                      Select
                                                    </option>
                                                    <option key="S" value="S">
                                                      Standard
                                                    </option>
                                                    <option key="P" value="P">
                                                      Premium
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div className="col-md-4">
                                                <div className="form-group">
                                                  <label>
                                                    Max Quantity{" "}
                                                    <span className="mendatory_class">
                                                      *
                                                    </span>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Type your message..."
                                                    value={
                                                      inhouseDetails.MaxQuantity
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        inhouseDetails: {
                                                          ...inhouseDetails,
                                                          MaxQuantity:
                                                            e.target.value,
                                                        },
                                                      })
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row">
                                              <div className="col-md-12">
                                                <div className="form-group">
                                                  <label>
                                                    Service Details{" "}
                                                    <span className="mendatory_class">
                                                      *
                                                    </span>
                                                  </label>
                                                  <textarea
                                                    onChange={(e) =>
                                                      this.setState({
                                                        inhouseDetails: {
                                                          ...inhouseDetails,
                                                          ServiceDetails:
                                                            e.target.value,
                                                        },
                                                      })
                                                    }
                                                    className="form-control"
                                                    rows={3}
                                                    value={
                                                      inhouseDetails.ServiceDetails
                                                    }
                                                    placeholder="Type here..."
                                                    defaultValue={""}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            {/*
                                          <div class="row">
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <div className="upload__box">
                                                  <div className="upload__btn-box">
                                                    <label className="upload__btn">
                                                      <p>
                                                        Upload Photos{" "}
                                                        <span className="upload_size">
                                                          ( Max 10 Photos, Max 2MB each )
                                                        </span>
                                                      </p>
                                                      <input type="file" data-max-length="10" data-max-size="2MB" className="upload__inputfile"
                                                      accept=".jpeg, .jpg, .png" multiple />
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          */}
                                            <div className="row">
                                              <div className="col-md-12">
                                                <div className="form-group">
                                                  <label>
                                                    Remark{" "}
                                                    <span className="mendatory_class">
                                                      *
                                                    </span>
                                                  </label>
                                                  <textarea
                                                    value={
                                                      inhouseDetails.Remark
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        inhouseDetails: {
                                                          ...inhouseDetails,
                                                          Remark:
                                                            e.target.value,
                                                        },
                                                      })
                                                    }
                                                    className="form-control"
                                                    rows={4}
                                                    placeholder="Type here..."
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row">
                                              <div className="col-md-12">
                                                <table
                                                  class="table table-bordered table-striped"
                                                  id="tbl"
                                                >
                                                  <thead>
                                                    <tr>
                                                      <th
                                                        style={{ width: "20%" }}
                                                      >
                                                        Quantity
                                                      </th>
                                                      <th
                                                        style={{ width: "20%" }}
                                                      >
                                                        Price In INR
                                                      </th>
                                                      <th
                                                        style={{ width: "20%" }}
                                                      >
                                                        Price In USD
                                                      </th>
                                                      <th
                                                        style={{ width: "20%" }}
                                                      >
                                                        Effective Date
                                                      </th>
                                                    </tr>
                                                  </thead>
                                                  <tbody id="myTable">
                                                    <tr>
                                                      <td>
                                                        <input
                                                          type="text"
                                                          style={{
                                                            width: "100px",
                                                          }}
                                                          className="form-control"
                                                          value={
                                                            inhouseDetails.Quantity
                                                          }
                                                          onChange={(e) => {
                                                            const value =
                                                              e.target.value;

                                                            const numericValue =
                                                              value
                                                                .replace(
                                                                  /[^0-9.]/g,
                                                                  ""
                                                                )
                                                                .replace(
                                                                  /(\..*)\./g,
                                                                  "$1"
                                                                );
                                                            this.setState({
                                                              inhouseDetails: {
                                                                ...inhouseDetails,
                                                                Quantity:
                                                                  numericValue,
                                                              },
                                                            });
                                                          }}
                                                        />
                                                      </td>
                                                      <td>
                                                        <input
                                                          type="text"
                                                          style={{
                                                            width: "100px",
                                                          }}
                                                          className="form-control"
                                                          value={
                                                            inhouseDetails.PriceInINR
                                                          }
                                                          onChange={(e) => {
                                                            const value =
                                                              e.target.value;

                                                            const numericValue =
                                                              value
                                                                .replace(
                                                                  /[^0-9.]/g,
                                                                  ""
                                                                )
                                                                .replace(
                                                                  /(\..*)\./g,
                                                                  "$1"
                                                                );
                                                            this.setState({
                                                              inhouseDetails: {
                                                                ...inhouseDetails,
                                                                PriceInINR:
                                                                  numericValue,
                                                              },
                                                            });
                                                          }}
                                                        />
                                                      </td>
                                                      <td>
                                                        <input
                                                          type="text"
                                                          style={{
                                                            width: "100px",
                                                          }}
                                                          className="form-control"
                                                          value={
                                                            inhouseDetails.PriceInUSD
                                                          }
                                                          onChange={(e) => {
                                                            const value =
                                                              e.target.value;

                                                            const numericValue =
                                                              value
                                                                .replace(
                                                                  /[^0-9.]/g,
                                                                  ""
                                                                )
                                                                .replace(
                                                                  /(\..*)\./g,
                                                                  "$1"
                                                                );
                                                            this.setState({
                                                              inhouseDetails: {
                                                                ...inhouseDetails,
                                                                PriceInUSD:
                                                                  numericValue,
                                                              },
                                                            });
                                                          }}
                                                        />
                                                      </td>
                                                      <td>
                                                        <DatePicker
                                                          className="form-control"
                                                          dateFormat="dd-MM-yyyy"
                                                          style={{
                                                            width: "100px",
                                                          }}
                                                          selected={
                                                            inhouseDetails.EffectiveDate
                                                          }
                                                          onChange={(e) =>
                                                            this.setState({
                                                              inhouseDetails: {
                                                                ...inhouseDetails,
                                                                EffectiveDate:
                                                                  e,
                                                              },
                                                            })
                                                          }
                                                          peekNextMonth
                                                          showMonthDropdown
                                                          showYearDropdown
                                                          dropdownMode="select"
                                                          placeholderText="EffectiveDate"
                                                          customInput={
                                                            <CustomInput />
                                                          }
                                                          dayClassName={() =>
                                                            "example-datepicker-day-class"
                                                          }
                                                          popperClassName="example-datepicker-class"
                                                        />
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                          {editIndex === null ||
                                            editIndex === "" ? (
                                            <Button
                                              variant="success"
                                              onClick={() =>
                                                this.submitInHouse()
                                              }
                                            >
                                              {" "}
                                              Save changes
                                            </Button>
                                          ) : (
                                            <Button
                                              variant="success"
                                              onClick={() =>
                                                this.editInHouse(editIndex)
                                              }
                                            >
                                              Save changes
                                            </Button>
                                          )}
                                          <Button
                                            variant="secondary"
                                            onClick={() => this.modalClose()}
                                          >
                                            {" "}
                                            Cancel
                                          </Button>
                                        </Modal.Footer>
                                      </Modal>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-12">
                        <div
                          class="card mb-3"
                          style={{ backgroundColor: "#f0f0f0" }}
                        >
                          <div class="card-body">
                            <label style={{
                              fontWeight: 600,
                              fontSize: 13,
                              marginBottom: 5,
                              color: "#232323",
                            }}
                            >
                              External Services
                            </label>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom_table">
                                  <div class="hack1">
                                    <div class="hack2">
                                      <table class="table table-bordered table-striped" id="tbl">
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10%" }}>Sr. no</th>
                                            <th style={{ width: "80%" }}>Service Name</th>
                                            <th class="text-right" style={{ width: "10%" }}>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody id="myTable">
                                          {externalList.length > 0 ? (externalList.filter((data) => data.isActive == 1)
                                            .map((data, index) => (
                                              <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                  {editedRowIndexExternal === index ? (
                                                    <select
                                                      className="form-control"
                                                      name="External Services"
                                                      value={externalDetails.ServiceID || data.ServiceID}
                                                      onChange={(e) => {
                                                        const selectedExternalServicesID = e.target.value;
                                                        const selectedExternalServices = e.target.options[e.target.selectedIndex].text;
                                                        this.setState({
                                                          externalDetails: {
                                                            ...externalDetails,
                                                            ServiceID: selectedExternalServicesID,
                                                            ServiceName: selectedExternalServices,
                                                          },
                                                        });
                                                      }}
                                                    >
                                                      <option value="">--Select--</option>
                                                      {externalServiceFillList.map(
                                                        (data) => (
                                                          <option
                                                            key={data.ExternalServicesID}
                                                            value={data.ExternalServicesID}
                                                          >{data.ExternalServices}</option>
                                                        )
                                                      )}
                                                    </select>
                                                  ) : (
                                                    (() => {
                                                      const externalServiceData = externalServiceFillList.find((item) => item.ExternalServicesID === data.ServiceID);
                                                      return externalServiceData ? `${externalServiceData.ExternalServices}` : "";
                                                    })()
                                                  )}
                                                </td>

                                                <td className="text-right">
                                                  {editedRowIndexExternal === index ? (
                                                    <>
                                                      <a title="Save" className="btn btn-sm padding_0"
                                                        onClick={() => this.saveEditedRowExternal(index)}>
                                                        <i className="fa fa-save action_btn_table" />
                                                      </a>
                                                      <a title="Cancel" className="btn btn-sm padding_0"
                                                        onClick={() => this.cancelEditRowExternal()}
                                                      ><i className="fa fa-times action_btn_table" />
                                                      </a>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <a title="Edit" className="btn btn-sm padding_0"
                                                        onClick={() => this.handleEditRowExternal(index, data)}
                                                      ><i className="fa fa-edit action_btn_table" />
                                                      </a>
                                                      <a title="Delete" className="btn btn-sm delete_record padding_0"
                                                        onClick={() => this.handleDeleteRowExternal(index, data.ExternalServicesID)}
                                                      ><i className="fa fa-trash action_btn_table" />
                                                      </a>
                                                    </>
                                                  )}
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td colSpan="3">No data available.</td>
                                            </tr>
                                          )}
                                          {showNewRowExternal && (
                                            <tr>
                                              <td></td>
                                              <td>
                                                <select className="form-control"
                                                  name="External Services"
                                                  value={externalDetails.ServiceID || data.ServiceID}
                                                  onChange={(e) => {
                                                    const selectedExternalServicesID = e.target.value;
                                                    const selectedExternalServices = e.target.options[e.target.selectedIndex].text;
                                                    this.setState({
                                                      externalDetails: {
                                                        ...externalDetails,
                                                        ServiceID: selectedExternalServicesID,
                                                        ServiceName: selectedExternalServices,
                                                      },
                                                    });
                                                  }}
                                                >
                                                  <option value="">--Select--</option>
                                                  {externalServiceFillList.map((data) => (
                                                    <option key={data.ExternalServicesID} value={data.ExternalServicesID}>{data.ExternalServices}</option>
                                                  ))}
                                                </select>
                                              </td>
                                              <td>
                                                <button
                                                  className="btn btn-primary btn-md"
                                                  onClick={() =>
                                                    this.handleAddRowExternal()
                                                  }
                                                >
                                                  Add
                                                </button>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                      <div>
                                        <a
                                          href="javascript:void(0);"
                                          class="btn btn-primary btn-sm create_btn add_additional_days_btn mb-3"
                                          style={{ width: "auto" }}
                                          onClick={() =>
                                            this.toggleNewRowExternal()
                                          }
                                        >
                                          <span class="hidden-xs">
                                            {showNewRowExternal
                                              ? "Cancel"
                                              : "Add"}
                                          </span>
                                        </a>
                                        {/* <button type="button" class="delete-row">Delete Row</button> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div
                          class="card mb-3"
                          style={{ backgroundColor: "#f0f0f0" }}
                        >
                          <div class="card-body">
                            <label
                              style={{
                                fontWeight: 600,
                                fontSize: 13,
                                marginBottom: 5,
                                color: "#232323",
                              }}
                            >
                              Security Checklist
                            </label>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom_table">
                                  <div class="hack1">
                                    <div class="hack2">
                                      <table
                                        class="table table-bordered table-striped"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10%" }}>
                                              Sr. no
                                            </th>
                                            <th style={{ width: "40%" }}>
                                              Checklist Name
                                            </th>
                                            <th style={{ width: "40%" }}>
                                              Allow To
                                            </th>
                                            <th
                                              class="text-right"
                                              style={{ width: "10%" }}
                                            >
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody id="myTable">
                                          {securityChecklist.length > 0 ? (
                                            securityChecklist
                                              .filter(
                                                (data) => data.isActive == 1)
                                              .map(
                                                (data, index) => (
                                                  <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                      {editedRowIndexSecurityChecklist ===
                                                        index ? (
                                                        <input
                                                          className="form-control"
                                                          value={
                                                            editedRowDataSecurityChecklist.Name ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            this.setState(
                                                              (prevState) => ({
                                                                editedRowDataSecurityChecklist:
                                                                {
                                                                  ...prevState.editedRowDataSecurityChecklist,
                                                                  Name: e.target
                                                                    .value,
                                                                },
                                                              })
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        data.Name
                                                      )}
                                                    </td>
                                                    <td>
                                                      {editedRowIndexSecurityChecklist ===
                                                        index ? (
                                                        <select
                                                          className="form-control"
                                                          name="Service"
                                                          value={editedRowDataSecurityChecklist.isClient || ""}
                                                          onChange={(e) => {
                                                            const selectedisClient = e.target.value;
                                                            this.setState(
                                                              (prevState) => ({
                                                                editedRowDataSecurityChecklist:
                                                                {
                                                                  ...prevState.editedRowDataSecurityChecklist,
                                                                  isClient: selectedisClient,
                                                                },
                                                              })
                                                            );
                                                          }}
                                                        >
                                                          <option value="">--Select--</option>
                                                          <option value={1}>Client</option>
                                                          <option value={0}>ITME</option>
                                                        </select>
                                                      ) : data.isClient == 1 ? ("Client") : ("ITME")}
                                                    </td>
                                                    <td className="text-right">
                                                      {editedRowIndexSecurityChecklist === index ? (
                                                        <>
                                                          <a title="Save"
                                                            className="btn btn-sm padding_0"
                                                            onClick={() => this.saveEditedRowSecurityChecklist(index)}
                                                          ><i className="fa fa-save action_btn_table" />
                                                          </a>
                                                          <a title="Cancel" className="btn btn-sm padding_0"
                                                            onClick={() => this.cancelEditRowSecurityChecklist()}
                                                          ><i className="fa fa-times action_btn_table" />
                                                          </a>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <a title="Edit"
                                                            className="btn btn-sm padding_0"
                                                            onClick={() =>
                                                              this.handleEditRowSecurityChecklist(index, data)}
                                                          >
                                                            <i className="fa fa-edit action_btn_table" />
                                                          </a>
                                                          <a
                                                            title="Delete"
                                                            className="btn btn-sm delete_record padding_0"
                                                            onClick={() => this.handleDeleteRowSecurityChecklist(index, data.CenterSecurityChecklistID)}
                                                          >
                                                            <i className="fa fa-trash action_btn_table" />
                                                          </a>
                                                        </>
                                                      )}
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                          ) : (
                                            <tr>
                                              <td colSpan="4">
                                                No data available.
                                              </td>
                                            </tr>
                                          )}
                                          {showNewRowSecurityChecklist && (
                                            <tr>
                                              <td></td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="name"
                                                  className="form-control"
                                                  value={
                                                    securityChecklistDetails.Name
                                                  }
                                                  onChange={(e) =>
                                                    this.setState({
                                                      securityChecklistDetails:
                                                      {
                                                        ...this.state
                                                          .securityChecklistDetails,
                                                        Name: e.target.value,
                                                      },
                                                    })
                                                  }
                                                  placeholder="Security Checklist Name"
                                                />
                                              </td>
                                              <td>
                                                <select
                                                  className="form-control"
                                                  name="Service"
                                                  value={
                                                    securityChecklistDetails.isClient
                                                  }
                                                  onChange={(e) => {
                                                    const selectedServiceID =
                                                      e.target.value;
                                                    this.setState({
                                                      securityChecklistDetails:
                                                      {
                                                        ...this.state
                                                          .securityChecklistDetails,
                                                        isClient:
                                                          selectedServiceID,
                                                      },
                                                    });
                                                  }}
                                                >
                                                  <option value="">
                                                    --Select--
                                                  </option>
                                                  <option value={1}>
                                                    Client
                                                  </option>
                                                  <option value={0}>
                                                    ITME
                                                  </option>
                                                </select>
                                              </td>
                                              <td>
                                                <button
                                                  className="btn btn-primary btn-md"
                                                  onClick={() =>
                                                    this.handleAddRowSecurityChecklist()
                                                  }
                                                >
                                                  Add
                                                </button>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                      <div>
                                        <a
                                          href="javascript:void(0);"
                                          class="btn btn-primary btn-sm create_btn add_additional_days_btn mb-3"
                                          style={{ width: "auto" }}
                                          onClick={() =>
                                            this.toggleNewRowSecurityChecklist()
                                          }
                                        >
                                          <span class="hidden-xs">
                                            {showNewRowSecurityChecklist
                                              ? "Cancel"
                                              : "Add"}
                                          </span>
                                        </a>
                                        {/* <button type="button" class="delete-row">Delete Row</button> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="mx-3 mt-3 mb-3">
                    <a
                      href="javascript:void(0);"
                      class="btn save_btn"
                      onClick={() => this.handleSubmit()}
                    >
                      {CenterID ? "Update" : "Save"}
                    </a>
                  </div>
                  <div class="mt-3 mb-3">
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateBackMultiCentre()}
                      class="btn back_btn"
                    >
                      Back
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </main>

          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    multi_purpose_centre_detail_action,
    multi_purpose_centre_add_action,
    fill_action,
  })(MultiPurposeCenterAdd)
);
